<template>
  <div class="inv-gen">
    <!-- 작업 순서대로 ①~⑤ 단계 구역(2026-10-06 YZY 「页面有些太乱了 浅绿色的文字看不清」) — 배치·대비만 바꿨다, 동작은 그대로 -->
    <!-- ① 方数计划 — 하루 한 번 올려 서버에 날짜별로 저장, 그날 출고리스트는 전부 여기서 尺寸·方数 를 채운다(2026-10-04 YZY) -->
    <section class="inv-gen__sec">
      <h6 class="inv-gen__sech"><span class="inv-gen__step">1</span>方数计划(방수계획) <small>按日期保存到服务器(날짜별로 서버에 저장)</small></h6>
      <div class="d-flex align-items-center flex-wrap inv-gen__gap">
        <input type="date" v-model="planDate" class="form-control form-control-sm" style="width:160px" title="方数计划日期(중국 날짜)" :disabled="planBusy">
        <label class="btn btn-sm btn-outline-primary mb-0">
          {{ planName ? '重新上传(다시 올리기)' : '上传方数计划(방수계획 업로드)' }}
          <input type="file" class="d-none" accept=".xlsx" :disabled="busy || planBusy" @change="onPlanFile">
        </label>
        <!-- 그 날짜 계획표 삭제(2026-10-06 YZY) — 잘못 올렸을 때 -->
        <b-button v-if="planName" size="sm" variant="outline-danger" :disabled="busy || planBusy" @click="deletePlan">🗑 删除方数计划(방수계획 삭제)</b-button>
        <span v-if="planBusy" class="inv-gen__msg inv-gen__msg--busy"><b-spinner small></b-spinner> 读取中(읽는 중)…</span>
      </div>
      <div v-if="!planBusy && planName" class="inv-gen__msg mt-2" :class="planMissing.length ? 'inv-gen__msg--warn' : 'inv-gen__msg--ok'">
        {{ planMissing.length ? '⚠' : '✓' }} 已应用 {{ planDate }} 方数计划 ({{ planName }}) · {{ plan.size }} 个托盘号<template v-if="planBy"> · {{ planBy }}</template><template v-if="model"> · 已选中未匹配(선택 중 계획표에 없음) {{ planMissing.length }}<template v-if="planMissing.length">: {{ planMissing.join(', ') }}</template></template>
      </div>
      <div v-else-if="!planBusy" class="inv-gen__msg inv-gen__msg--err mt-2">✕ 当天未上传方数计划(이 날짜 방수계획 없음)</div>
    </section>

    <!-- ② 출고리스트 업로드 — 综合清关 / 单独清关 두 칸 나란히, 칸마다 여러 파일(2026-10-06 YZY) -->
    <section class="inv-gen__sec">
      <h6 class="inv-gen__sech"><span class="inv-gen__step">2</span>上传出库清单(출고리스트 업로드) <small>上传即保存到服务器·自动出库，有问题的去「出库列表 → 待出库列表」里的「待手动匹配」处理(올리면 서버 저장·자동 출고, 남은 행은 待出库列表 탭의 待手动匹配 구역에서)</small></h6>
      <!-- 출고리스트 저장본(待出库 탭에서 그 날짜로 올린 것) — 있으면 파일을 또 올리지 않고 그대로 쓴다(2026-10-06 출고 흐름 통일 §2·§4).
           清关方式 = 파렛트라벨 → 구매요청 통관유형, 없으면 고른 칸. 데이터와 칸이 다르면 빨간 표시(생성은 막지 않는다) -->
      <div v-if="savedBusy" class="inv-gen__msg inv-gen__msg--busy mb-2"><b-spinner small></b-spinner> 读取保存的出库清单(저장된 출고리스트 읽는 중)…</div>
      <div v-else-if="savedFiles.length" class="inv-gen__ubox mb-2">
        <!-- 평소엔 제목 한 줄 + 개수만, 누르면 펼친다(2026-10-07 YZY). 펼침 상태는 브라우저에 기억(못 읽으면 접힘) -->
        <div class="inv-gen__ulabel" role="button" style="cursor:pointer" @click="toggleSavedOpen">
          {{ savedOpen ? '▼' : '▶' }} 📦 {{ planDate }} 已保存的出库清单(저장된 출고리스트) {{ savedFiles.length }}个
          <span v-if="!savedOpen && savedConflictCount" class="text-danger ml-1">⚠ 与清关方式不同(칸과 다름) {{ savedConflictCount }}</span>
        </div>
        <table v-if="savedOpen" class="table table-sm table-bordered mb-0 mt-1 bg-white">
          <thead class="thead-light"><tr><th>文件(파일)</th><th style="width:170px">清关方式(통관 칸)</th><th>数据(데이터 통관유형: 파렛트라벨→구매요청)</th><th v-if="deleteOutbound" style="width:1%"></th></tr></thead>
          <tbody>
            <tr v-for="f in savedFiles" :key="'sf' + f.fileName" :class="{ 'inv-gen__row-warn': savedConflict(f).length }">
              <td class="small">{{ f.fileName }} <span class="text-muted">· {{ (f.rows || []).length }}行</span>
                <div v-if="f.keptReason" class="text-danger">⚠ 部分出库保留(일부 출고 유지 — 이미 다음 단계로 넘어간 행이 있어 파일을 남겼습니다)</div></td>
              <td>
                <select class="form-control form-control-sm" :value="savedSlot[f.fileName]" :disabled="busy" @change="setSavedSlot(f.fileName, $event.target.value)">
                  <option value="integrated">综合清关(통합)</option>
                  <option value="separate">单独清关(단독)</option>
                  <option value="">不用(안 씀)</option>
                </select>
              </td>
              <td class="small">
                <span v-for="(n, t) in savedTypes(f)" :key="'st' + f.fileName + t" class="badge badge-light border mr-1">{{ customsLabel(t) }} {{ n }}</span>
                <div v-if="savedConflict(f).length" class="text-danger font-weight-bold">
                  ⚠ 与清关方式不同(칸과 다름): {{ savedConflict(f).slice(0, 6).join(', ') }}<template v-if="savedConflict(f).length > 6"> 外 {{ savedConflict(f).length - 6 }}</template>
                </div>
              </td>
              <!-- 파일 삭제(2026-10-07 YZY) — 待出库 의 「删除文件」 과 같은 동작(그 파일로 나간 행 출고 취소 → 저장본 숨김, 다음 단계 행이 있으면 일부 출고 유지) -->
              <td v-if="deleteOutbound" class="text-nowrap">
                <b-button size="sm" variant="link" class="text-danger p-0" :disabled="busy || !!savedDeleting || savedJobRunning(f)" :title="savedJobRunning(f) ? '自动出库进行中，完成后再删除(자동 출고 진행 중 — 끝난 뒤 삭제)' : ''" @click="deleteSaved(f)">
                  <b-spinner v-if="savedDeleting === f.fileName" small></b-spinner> 删除文件(파일 삭제)
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="saveMsg" class="inv-gen__msg mb-2" :class="saveBusy ? 'inv-gen__msg--busy' : 'inv-gen__msg--ok'"><b-spinner v-if="saveBusy" small></b-spinner> {{ saveMsg }}
        <!-- 남은 행 = 出库列表 → 待出库列表 탭 맨 위 待手动匹配 구역(2026-10-07 #1165 통합, 옛 별도 메뉴 없음) -->
        <router-link v-if="!saveBusy" :to="{ name: 'logis.warehousemanagement', query: { view: 'manual' } }" class="ml-1">→ 待手动匹配(수동 매칭 대기)</router-link></div>
      <div v-if="!savedBusy && !savedFiles.length" class="small text-muted mb-2">{{ planDate }} 没有保存的出库清单 — 请在下面上传(저장된 출고리스트 없음 — 아래에서 파일을 올려 주세요)</div>
      <div class="row">
        <div v-for="u in uploadKinds" :key="u.key" class="col-lg-6 mb-2">
          <div class="inv-gen__ubox">
            <div class="inv-gen__ulabel">📄 {{ u.label }}</div>
            <div class="d-flex align-items-center flex-wrap inv-gen__gap">
              <!-- 한 번에 여러 개 고르고, 다시 고르면 이미 올린 파일에 더한다(같은 이름은 교체) — 2026-10-06 YZY 「同时上传多个文件 合并到一起识别」 -->
              <label class="btn btn-sm btn-outline-primary mb-0" :title="'可一次选多个文件；再选会追加到已上传的文件，同名文件替换(여러 개 한 번에 선택 가능 · 다시 고르면 추가, 같은 이름은 교체)'">
                {{ lists[u.key] ? '+ 追加文件(파일 추가)' : '选择文件(파일 선택) · 可多选' }}
                <input type="file" multiple class="d-none" accept=".xlsx" :disabled="busy" @change="onFiles($event, u.key)">
              </label>
              <template v-if="u.key === 'integrated'">
                <span class="small">默认收货人(기본 수취인)</span>
                <!-- 기본값 — ④ 에서 箱单发票 세트마다 바꿀 수 있다(2026-10-06 YZY) -->
                <select v-model="integratedTo" class="form-control form-control-sm" style="width:140px" title="综合清关默认收货人，可在 ④ 每套单独更改(통합통관 기본 수취인 — ④ 에서 세트마다 바꿀 수 있음)">
                  <option v-for="rc in recipients" :key="rc.id" :value="rc.id">{{ rc.label }}</option>
                </select>
              </template>
            </div>
            <template v-if="lists[u.key]">
              <div class="inv-gen__msg inv-gen__msg--ok mt-2">✓ 已合并 {{ lists[u.key].names.length - lists[u.key].skipped.length }} 个文件(파일 합침) · {{ lists[u.key].palletCount }} 个托盘号</div>
              <!-- 핵심 칸이 다른 양식인 파일은 빼고 합친다 — 어느 파일·어느 열인지 보여준다(✕ 로 빼거나 고쳐서 다시 올린다) -->
              <div v-for="s in lists[u.key].skipped" :key="'skip' + u.key + s.name" class="inv-gen__msg inv-gen__msg--warn mt-1">
                ⚠ 「{{ s.name }}」 格式不同，未合并(양식이 달라 합치지 않았습니다): {{ skippedText(s) }}
              </div>
              <!-- 다른 파일엔 있는데 이 파일엔 없는 칸 — 합치되 그 파일 행은 빈 값 -->
              <div v-for="s in lists[u.key].missing" :key="'miss' + u.key + s.name" class="inv-gen__msg inv-gen__msg--warn mt-1">
                ⚠ 「{{ s.name }}」 没有「{{ s.cols.join('、') }}」列，已合并，这些列为空(이 파일엔 {{ s.cols.join(', ') }} 칸이 없어 빈 값으로 합쳤습니다)
              </div>
              <!-- 올린 파일 목록 — 한 개씩 뺄 수 있다 -->
              <div class="d-flex flex-wrap align-items-center inv-gen__gap small mt-2">
                <span v-for="n in lists[u.key].names" :key="u.key + n" class="badge badge-light border inv-gen__fname" :class="{ 'border-danger text-danger': lists[u.key].skipped.some(s => s.name === n) }">
                  {{ n }} <a href="#" class="text-danger ml-1" title="删除这个文件(이 파일 빼기)" @click.prevent="removeFile(u.key, n)">✕</a>
                </span>
                <a href="#" class="text-danger" @click.prevent="removeFile(u.key, null)">全部清除(전체 삭제)</a>
              </div>
              <!-- 合包(N P打包) 申报单价 = 낱개 단가 × N 자동 계산. 직원이 인식 실패 건을 이미 ×N 으로 고쳐 올린 파일이면 끈다(두 번 곱해지지 않게) -->
              <label class="small mt-1 mb-0 d-block"><input v-model="packOff[u.key]" type="checkbox" class="mr-1" @change="onPackToggle(u.key)">合包单价已是×N，不再相乘(「NP打包」 단가가 이미 ×N 으로 고쳐진 파일 — 곱하지 않음)</label>
              <!-- 화주별 출고리스트는 箱单发票列表 날짜 박스로 옮겼다(2026-10-07 YZY) -->
              <div class="small text-muted mt-1">按货主拆分出库清单 → 在「箱单发票列表」选日期下载(화주별 출고리스트는 箱单发票列表 에서 날짜를 골라 내려받기)</div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="busy" class="inv-gen__msg inv-gen__msg--busy"><b-spinner small></b-spinner> 读取中(읽는 중)…</div>
      <div v-if="error" class="inv-gen__msg inv-gen__msg--err mt-1">✕ {{ error }}</div>
      <details class="inv-gen__help mt-2">
        <summary>ⓘ 说明(도움말)</summary>
        两栏都可一次选多个文件，再选会追加(同名替换，✕ 可单个删除)。综合清关全部合并后按方数计划的粗框分套；单独清关按出库清单L列(货主)分套。也可以在下面选托盘号单独生成。出库清单上传后按日期保存到服务器并自动出库(출고리스트는 올리면 날짜별로 서버에 저장·자동 출고); 方数计划按日期保存到服务器(두 칸 모두 여러 파일을 한 번에 고를 수 있고, 다시 고르면 추가됩니다 — 같은 이름은 교체, ✕ 로 하나씩 빼기. 통합통관은 여러 파일을 합쳐 방수계획 굵은 테두리 칸마다 한 세트, 단독통관은 L열 화주마다 한 세트로 일괄 생성합니다. 아래에서 파렛트번호를 골라 한 건씩 만들 수도 있습니다).
      </details>
    </section>

    <!-- ③ 单独清关 화주별 收货人 매칭 + 产地证 종류(2026-10-06 YZY) — 营业执照 이 하나면 자동, 여럿이면 고르고, 없으면 그 자리에서 올린다 -->
    <section class="inv-gen__sec">
      <h6 class="inv-gen__sech">
        <span class="inv-gen__step">3</span>收货人·产地证设置(수취인·원산지증명 설정)
        <small v-if="ownerMatches.length">单独清关 · 已匹配(매칭) {{ ownerMatches.filter(m => m.options.length || m.byKeyword).length }} / {{ ownerMatches.length }}</small>
      </h6>
      <template v-if="ownerMatches.length">
        <div class="d-flex align-items-center flex-wrap inv-gen__gap mb-2 small">
          <router-link :to="{ name: 'logis.invoicelicenses' }" target="_blank">管理营业执照(사업자등록증 관리) ↗</router-link>
          <b-button size="sm" variant="link" class="p-0" :disabled="imgBusy" title="管理页面改了以后刷新(관리 화면에서 바꾼 뒤 새로고침)" @click="loadImageList">↻ 刷新(새로고침)</b-button>
          <b-spinner v-if="imgBusy" small></b-spinner>
        </div>
        <!-- 화주 합치기(2026-10-07 YZY) — 한 고객이 계정 여러 개일 때 한 세트(한 수입자)로. 대표 화주의 营业执照·产地证·서류 기록으로 나간다 -->
        <div v-if="ownerMatches.length > 1" class="d-flex align-items-center flex-wrap inv-gen__gap mb-2 small">
          <span>合并货主为一套(화주 합쳐 한 세트로): 已选 {{ mergePick.length }}</span>
          <select v-model="mergeRep" class="form-control form-control-sm" style="width:auto" :disabled="mergePick.length < 2" title="代表货主 = 营业执照·收货人·产地证用这个(대표 화주)">
            <option value="">代表货主(대표 화주) — {{ mergePick[0] || '先勾选(먼저 체크)' }}</option>
            <option v-for="c in mergePick" :key="'mr' + c" :value="c">{{ c }}</option>
          </select>
          <b-button size="sm" variant="outline-primary" :disabled="mergePick.length < 2" @click="mergeOwners">合并(합치기)</b-button>
        </div>
        <div class="table-responsive">
          <table class="table table-sm table-bordered mb-0 inv-gen__preview inv-gen__match">
            <thead class="thead-light">
              <tr><th>货主(화주)</th><th>托盘号(파렛트)</th><th>营业执照(사업자등록증)</th><th>收货人(수취인)</th><th style="width:220px">产地证种类(원산지증명 종류)</th></tr>
            </thead>
            <tbody>
              <tr v-for="m in ownerMatches" :key="'om' + m.co" :class="{ 'inv-gen__row-warn': !m.options.length && !m.byKeyword }">
                <td class="text-nowrap">
                  <label class="mb-0 font-weight-bold"><input v-model="mergePick" type="checkbox" class="mr-1" :value="m.co" title="勾选后可合并为一套(체크해서 한 세트로 합치기)">{{ m.co }}</label>
                  <!-- 합친 세트 — 원래 화주들(서류 기록에 남는다), 해제 가능 -->
                  <div v-if="m.members.length > 1" class="small">
                    <span class="badge badge-primary">合并(합침)</span><span v-if="autoOwnerLic[m.co]" class="badge badge-info ml-1" title="同一营业执照自动合并(같은 영업집조라 자동으로 합침 — 해제하면 다시 안 합칩니다)">自动(자동)</span> <span class="text-muted">{{ m.members.join(' + ') }}</span>
                    <a href="#" class="ml-1" @click.prevent="unmergeOwner(m.co)">取消合并(해제)</a>
                  </div>
                </td>
                <td class="small">{{ m.ids.length }}托 <span class="text-muted">{{ m.ids[0] }}<template v-if="m.ids.length > 1"> ~ {{ m.ids[m.ids.length - 1] }}</template></span></td>
                <td>
                  <!-- 이 화주 营业执照 없음 → 그 자리에서 올린다(올리면 수취인 정보 입력 창이 뜬다) -->
                  <div v-if="!m.options.length && !m.byKeyword" class="d-flex align-items-center flex-wrap inv-gen__gap mb-1">
                    <span class="text-danger small">⚠ 未匹配到营业执照(등록된 사업자등록증 없음)</span>
                    <label class="btn btn-sm btn-outline-danger mb-0" :class="{ disabled: imgBusy }">
                      单独上传(이 화주 사업자등록증 올리기)
                      <input type="file" accept="image/png,image/jpeg" class="d-none" :disabled="imgBusy" @change="onOwnerLicenseFile($event, m.co)">
                    </label>
                  </div>
                  <!-- 수동 변경(2026-10-06 YZY) — 이 화주 것 + COUPASS(고정 수취인) + 다른 화주 중에서 고른다. 单独清关 이라도 COUPASS 명의로 낼 때 -->
                  <!-- 营业执照 검색 + 클릭 선택(2026-10-08 YZY) — 칸을 누르면 목록이 열리고, 글자를 치면 거른다(상호·사업자번호 등 licenseText 에 보이는 글자). 항목을 누르면 고른다 -->
                  <div class="inv-gen__lic">
                    <input type="text" class="form-control form-control-sm" autocomplete="off" :value="licOpen === m.co ? licQuery : licPickedText(m)"
                      :placeholder="licPickedText(m) || '— 选择营业执照(사업자등록증 선택) —'" title="输入关键字搜索并点选；也可选COUPASS(글자를 쳐서 검색하고 눌러 선택 — COUPASS 명의도 가능)"
                      @focus="openLic(m.co)" @input="licQuery = $event.target.value" @blur="closeLic(m.co)" @keydown.esc="$event.target.blur()">
                    <div v-if="licOpen === m.co" class="inv-gen__lic-list">
                      <template v-for="g in licFiltered(m)">
                        <div :key="'lgh' + m.co + g.key" class="inv-gen__lic-grp">{{ g.label }}</div>
                        <div v-for="l in g.list" :key="'lgi' + m.co + l._id" class="inv-gen__lic-item" :class="{ 'is-on': l._id === m.licenseId }" @mousedown.prevent="chooseLic(m.co, l._id)">{{ licenseText(l) }}</div>
                      </template>
                      <div v-if="!licFiltered(m).length" class="inv-gen__lic-grp">没有结果(검색 결과 없음)</div>
                    </div>
                  </div>
                  <div class="small mt-1">
                    <span v-if="m.fixed" class="badge badge-info">{{ m.clearanceLabel }}</span><span v-if="m.byKeyword" class="text-muted ml-1">表内注明，自动匹配COUPASS(표에 「쿠패스단독통관」 — COUPASS 로 자동)</span>
                    <span v-else-if="m.license && !m.picked && m.options.length === 1" class="text-success">✓ 自动匹配(자동)</span>
                    <span v-else-if="m.license && !m.picked" class="text-muted">有 {{ m.options.length }} 张，可选择(여러 장 — 고를 수 있음)</span>
                  </div>
                </td>
                <td class="small">
                  <template v-if="m.license">
                    <template v-if="m.consignee.name">
                      <div class="font-weight-bold">{{ m.consignee.name }}</div>
                      <div class="text-muted">{{ [m.consignee.addr1, m.consignee.addr2].filter(Boolean).join(' ') }}</div>
                    </template>
                    <span v-else class="text-warning">⚠ 收货人信息未填写(수취정보 비어 있음)</span>
                    <a href="#" class="d-block" @click.prevent="openRecipient(m.license, m.co)">✎ 填写收件人信息(수취인 정보 입력)</a>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <select class="form-control form-control-sm" :style="cooStyle(setCooOf('o:' + m.co))" :value="setCooOf('o:' + m.co)" @change="setSetCoo('o:' + m.co, $event.target.value)">
                    <option v-for="t in cooChoices" :key="'omc' + t.code" :value="t.code" :style="cooStyle(t.code)">{{ t.label }}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <details class="inv-gen__help mt-2">
          <summary>ⓘ 说明(도움말)</summary>
          批量生成时每个货主用这里选的营业执照(收货人)和产地证种类，默认韩中FTA产地证(일괄 생성 때 화주마다 여기서 고른 사업자등록증·수취인과 원산지증명 종류로 만듭니다. 기본은 韩中FTA). 综合清关的收货人和产地证种类在 ④ 里每套选择(통합통관은 수취인·원산지증명을 ④ 에서 세트마다 고릅니다).
        </details>
      </template>
      <div v-else class="inv-gen__empty">上传单独清关出库清单后，在这里按货主匹配收货人·产地证(단독통관 출고리스트를 올리면 여기서 화주별 수취인·원산지증명을 맞춥니다)</div>
    </section>

    <!-- ④ 일괄 생성 — 세트마다 箱单发票 + 产地证, zip 하나로(2026-10-06 YZY). 이 화면의 주 동작 = 여기 버튼만 강조 -->
    <section class="inv-gen__sec inv-gen__sec--main">
      <h6 class="inv-gen__sech"><span class="inv-gen__step">4</span>批量生成·下载(일괄 생성·다운로드) <small>每套 = 箱单发票 + 产地证，打包成一个zip(세트마다 인보이스+원산지증명, zip 하나)</small></h6>
      <template v-if="batchViews.length">
        <div v-for="b in batchViews" :key="'b' + b.key" class="inv-gen__batch">
          <div class="d-flex align-items-center flex-wrap inv-gen__gap">
            <b-button variant="primary" class="inv-gen__cta" :disabled="batchBusy || !!b.blocker || !b.sets.length" @click="downloadBatch(b.key)">⬇ {{ b.label }} · {{ b.sets.length }} 套(세트)</b-button>
            <span v-if="b.blocker" class="inv-gen__msg inv-gen__msg--err">✕ {{ b.blocker }}</span>
            <span v-else-if="b.note" class="inv-gen__msg inv-gen__msg--warn">⚠ {{ b.note }}</span>
          </div>
          <!-- 세트마다 产地证 종류 — 综合清关 은 여기서 고르고, 单独清关 은 ③ 수취인 매칭 표에서 고른다(기본 韩中FTA) -->
          <div v-if="b.sets.length" class="d-flex flex-wrap inv-gen__gap mt-2 small">
            <!-- 번호 = 파일명 순번(方数计划 굵은 테두리 순서, 单独 은 综合 다음부터 — 2026-10-06 YZY) -->
            <span v-for="(s, si) in b.sets" :key="b.key + si" class="badge border inv-gen__set d-inline-flex align-items-center" :class="s.missing ? 'badge-warning' : 'badge-light'" :title="'INVOICE_' + s.docBase + '\n' + s.ids.join(', ')">
              {{ s.seq }}. {{ s.title }} · {{ s.ids.length }}托 ·
              <span v-if="b.key === 'separate' && ownerLicenseOf(s.co).fixed" class="badge badge-info mr-1">{{ ownerLicenseOf(s.co).clearanceLabel }}</span>
              <!-- 综合清关 收货人 — 세트마다(기본 = ② 의 默认收货人, 2026-10-06 YZY). 파일명·收货人·서류 기록에 반영 -->
              <select v-if="b.key === 'integrated'" class="form-control form-control-sm ml-1 inv-gen__setcoo" :class="{ 'border-primary font-weight-bold': s.rcpt !== integratedTo }" :value="s.rcpt" title="这套的收货人(이 세트 수취인)" @change="setSetRecipient(s.cooKey, $event.target.value)">
                <option v-for="rc in recipients" :key="'sr' + rc.id" :value="rc.id">收货人 {{ rc.label }}</option>
              </select>
              <!-- 产地证 种类 — 3종 + 「无需做产地证」 한 드롭다운(2026-10-08 YZY). 기본 = 箱单发票 총금액 ${{ cooMinUsd }} 미만이면 无需做产地证, 이상이면 韩中FTA. 단독통관은 ③ 에서 고른 값을 본다 -->
              <select v-if="b.key === 'integrated'" class="form-control form-control-sm ml-1 inv-gen__setcoo" :style="cooStyle(setCooOf(s.cooKey, s.amount))" :value="setCooOf(s.cooKey, s.amount)"
                :title="'产地证种类(원산지증명 종류) · 箱单发票总金额 $' + s.amount.toFixed(2) + (cooNeededFor(s.amount) ? '' : ' < $' + cooMinUsd)" @change="setSetCoo(s.cooKey, $event.target.value)">
                <option v-for="t in cooChoices" :key="'sc' + t.code" :value="t.code" :style="cooStyle(t.code)">{{ t.label }}</option>
              </select>
              <span v-else class="ml-1 badge" :style="cooStyle(setCooOf(s.cooKey, s.amount))" :title="'箱单发票总金额 $' + s.amount.toFixed(2)">{{ cooLabel(setCooOf(s.cooKey, s.amount)) }}<template v-if="setCooOf(s.cooKey, s.amount) === cooNoneCode"> (원산지증명 불필요 · ${{ s.amount.toFixed(2) }})</template></span>
              <!-- 세트 총 体积·毛重(2026-10-07 YZY) — 고치면 托盘 마다 자동값 비율로 나눠 이 세트 서류(箱单发票·BL 대조 기준)에 쓴다. 원본 출고리스트는 그대로 -->
              <!-- 칸 순서·이름은 미리보기·PA 와 같게(毛重 → 体积), 이름을 칸 앞에 붙이고 단위는 칸 뒤에 — CBM/kg 이 어느 칸 것인지 헷갈리지 않게(2026-10-08 YZY) -->
              <span class="ml-2 font-weight-bold" title="这套合计(세트 합계)">Σ 毛重 G/W</span>
              <input type="number" step="1" min="0" class="form-control form-control-sm ml-1 inv-gen__vol" :class="{ 'inv-gen__edited': s.vol.editGw }" :value="s.vol.gw"
                :title="'这套总毛重(kg)，可修改(세트 총중량 — 고칠 수 있음) · 自动(자동) ' + s.vol.autoGw" @change="editSetVol(b.key, s, 'gw', $event.target.value)"><span class="ml-1">kg</span>
              <span class="ml-2 font-weight-bold">体积 CBM</span>
              <input type="number" step="0.01" min="0" class="form-control form-control-sm ml-1 inv-gen__vol" :class="{ 'inv-gen__edited': s.vol.editCbm }" :value="s.vol.cbm"
                :title="'这套总体积(m³)，可修改(세트 총 부피 — 고칠 수 있음) · 自动(자동) ' + s.vol.autoCbm" @change="editSetVol(b.key, s, 'cbm', $event.target.value)"><span class="ml-1">m³</span>
              <a v-if="s.vol.editCbm || s.vol.editGw" href="#" class="ml-1 font-weight-bold" title="恢复自动值(자동값으로 되돌리기)" @click.prevent="revertSetVol(b.key, s)">↺ 自动值</a>
              <a href="#" class="ml-2" title="按托盘号修改体积·毛重(파렛트별 부피·중량 수정)" @click.prevent="toggleVolOpen(b.key + s.cooKey)">{{ volOpen[b.key + s.cooKey] ? '▲' : '✎' }} 托盘</a>
            </span>
          </div>
          <!-- 세트의 托盘 별 体积·毛重 수정(펼친 세트만) — ⑤ 한 건 생성과 같은 수정값을 쓴다 -->
          <template v-for="s in b.sets">
            <div v-if="volOpen[b.key + s.cooKey]" :key="'vo' + b.key + s.cooKey" class="table-responsive mt-2">
              <table class="table table-sm table-bordered mb-0 inv-gen__preview inv-gen__voltab">
                <thead class="thead-light"><tr><th>{{ s.seq }}. 托盘号(파렛트)</th><th>毛重 G/W(kg)</th><th>体积 CBM(m³)</th></tr></thead>
                <tbody>
                  <tr v-for="r in s.vol.rows" :key="'vr' + b.key + r.p.id">
                    <td>{{ r.p.id }}<span v-if="r.boxGw" class="small text-muted"> · 散货 {{ r.boxGw.length }}BOX</span></td>
                    <td>
                      <div class="d-flex align-items-center inv-gen__gap">
                        <input type="number" step="0.01" min="0" class="form-control form-control-sm" :class="{ 'inv-gen__edited': r.edit.gw }" :value="r.gw"
                          :title="r.boxGw ? '散货按箱子自动值比例分配(散货 는 박스별 자동값 비율로 나눕니다)' : ''" @change="editVol(b.key, r.p, null, 'gw', $event.target.value)">
                        <a v-if="r.edit.gw" href="#" class="small text-nowrap" title="恢复自动值(자동값으로)" @click.prevent="editVol(b.key, r.p, null, 'gw', '')">↺ {{ r.p.auto.gw }}</a>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center inv-gen__gap">
                        <input type="number" step="0.01" min="0" class="form-control form-control-sm" :class="{ 'inv-gen__edited': r.edit.cbm }" :value="r.cbm" @change="editVol(b.key, r.p, null, 'cbm', $event.target.value)">
                        <a v-if="r.edit.cbm" href="#" class="small text-nowrap" title="恢复自动值(자동값으로)" @click.prevent="editVol(b.key, r.p, null, 'cbm', '')">↺ {{ r.p.auto.cbm }}</a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <div v-if="b.sets.length" class="small text-muted mt-1">文件名(파일명): INVOICE_{{ b.sets[0].docBase }}<template v-if="b.sets.length > 1"> … INVOICE_{{ b.sets[b.sets.length - 1].docBase }}</template></div>
        </div>
        <div v-if="batchBusy" class="inv-gen__msg inv-gen__msg--busy"><b-spinner small></b-spinner> 生成中(만드는 중)…</div>
        <div v-if="batchMsg" class="inv-gen__msg" :class="batchErr ? 'inv-gen__msg--err' : 'inv-gen__msg--ok'">{{ batchErr ? '✕' : '✓' }} {{ batchMsg }}</div>
      </template>
      <div v-else class="inv-gen__empty">上传出库清单后在这里一键生成(출고리스트를 올리면 여기서 한 번에 만듭니다)</div>
    </section>

    <!-- ⑤ 托盘号 골라 한 건씩 만들기 -->
    <section class="inv-gen__sec">
      <!-- 평소엔 접어 둔다 — 「펼치기」로 연다(2026-10-06 YZY) -->
      <h6 class="inv-gen__sech mb-0">
        <span class="inv-gen__step">5</span>按托盘号单独生成(파렛트별 한 건씩 만들기) <small v-if="pallets.length">{{ fileName }}</small>
        <b-button size="sm" variant="outline-secondary" class="ml-auto" @click="singleOpen = !singleOpen">{{ singleOpen ? '▲ 收起(접기)' : '▼ 展开(펼치기)' }}</b-button>
      </h6>
      <template v-if="singleOpen">
      <div v-if="!pallets.length" class="inv-gen__empty mt-2">上传出库清单后可选托盘号单独生成(출고리스트를 올리면 파렛트번호를 골라 한 건씩 만들 수 있습니다)</div>
    <template v-if="pallets.length">
      <!-- 托盘号 선택 -->
      <div class="d-flex align-items-center flex-wrap mb-2 inv-gen__gap">
        <b-form-radio-group v-if="lists.integrated && lists.separate" :checked="mode" :options="modeOptions" buttons size="sm" button-variant="outline-primary" @change="useList"></b-form-radio-group>
        <span class="font-weight-bold">选择托盘号(파렛트 선택)</span>
        <select v-model="companyFilter" class="form-control form-control-sm" style="width:180px">
          <option value="">全部货主(화주 전체)</option>
          <option v-for="c in companyOptions" :key="'co' + c" :value="c">{{ ownerText(c) }}</option>
        </select>
        <!-- 托盘号 은 여러 개 고를 수 있다(2026-10-04 YZY) — 아무것도 안 고르면 전체 -->
        <b-dropdown size="sm" variant="outline-secondary" :text="palletFilterText" class="inv-gen__pfilter">
          <b-dropdown-form>
            <div class="d-flex inv-gen__gap mb-1 small">
              <a href="#" @click.prevent="palletFilter = palletOptions.slice()">全选(전체 선택)</a>
              <a href="#" @click.prevent="palletFilter = []">清除(해제)</a>
            </div>
            <b-form-checkbox-group v-model="palletFilter" :options="palletOptions" stacked></b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>
        <b-button size="sm" variant="outline-primary" :disabled="!filteredPallets.length" @click="selectFiltered(!allFilteredSelected)">
          {{ allFilteredSelected ? '取消全选(전체 해제)' : '全选(筛选结果 전체 선택) ' + filteredPallets.length }}
        </b-button>
        <span class="small text-muted">已选(선택) {{ selected.length }}</span>
      </div>
      <div class="table-responsive inv-gen__pallets">
        <table class="table table-sm table-bordered table-hover mb-0">
          <thead class="thead-light">
            <tr>
              <th style="width:36px"><input type="checkbox" title="全选(전체 선택)" :checked="allFilteredSelected" :disabled="!filteredPallets.length" @change="selectFiltered($event.target.checked)"></th>
              <th>托盘号(파렛트번호)</th><th>货主(화주)</th><th>行数(행)</th><th>数量(수량)</th><th>箱数(박스)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in filteredPallets" :key="p.id" :class="{ 'table-active': selected.includes(p.id) }">
              <td><input type="checkbox" :value="p.id" v-model="selected"></td>
              <td>
                {{ p.id }}
                <!-- 散货 는 托盘 이 없으니 箱号 를 보여준다(2026-10-04 YZY) -->
                <div v-if="p.loose && p.boxCodes.length" class="small text-muted">箱号(박스): {{ p.boxCodes.join(', ') }}</div>
              </td>
              <td>{{ p.companyids.map(ownerText).join(', ') }}
                <!-- 综合清关 은 COUPASS 명의 — 원래 화주를 작게 같이 보여준다(2026-10-04 YZY) -->
                <div v-if="p.origCompanyids && p.origCompanyids.join() !== p.companyids.join()" class="small text-muted">综合清关 · 原货主(원 화주) {{ p.origCompanyids.join(', ') }}</div></td>
              <td>{{ p.행수 }}</td>
              <td>{{ p.수량 }}</td>
              <td>{{ p.박스수 }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <template v-if="model">
        <div v-for="(w, wi) in model.warnings" :key="'w' + wi" class="inv-gen__msg inv-gen__msg--warn mt-1">⚠ {{ w }}</div>
        <div v-if="fixedRowCount" class="inv-gen__msg inv-gen__fixedmsg mt-1">固定申报金额已应用 {{ fixedRowCount }} 行(고정 申报金额 적용 {{ fixedRowCount }}행) — 黄色行的申报单价来自「韩文标签资料」，合包也不乘N(노란 행의 申报单价는 韩文标签资料 고정금액이며 합포장도 ×N 안 함)</div>
        <div v-if="fixedErr" class="inv-gen__msg inv-gen__msg--err mt-1">✕ {{ fixedErr }}</div>

        <!-- ⑤-a 머리 정보 -->
        <b-card class="mt-3" body-class="p-2">
          <div class="inv-gen__subh">📝 单据信息(문서 정보) <small class="text-muted">— 自动保存在本浏览器(이 브라우저에 자동 저장)</small></div>
          <div class="form-row">
            <div class="col-md-4">
              <label class="small mb-0">发货人 Shipper/Exporter(수출자)</label>
              <!-- 미리 저장한 发货人 에서 고른다(2026-10-04 YZY). 고르면 아래 칸과 印章 이 같이 바뀐다 -->
              <div class="d-flex inv-gen__gap mb-1">
                <select v-model="shipperId" class="form-control form-control-sm" @change="pickShipper">
                  <option v-for="sp in shipperOptions" :key="sp._id" :value="sp._id">{{ sp.name }}</option>
                </select>
                <b-button size="sm" variant="outline-primary" class="text-nowrap" :disabled="imgBusy" title="把下面的内容和印章保存到所选发货人(아래 내용·도장을 고른 발송인에 저장)" @click="saveShipper(false)">保存(저장)</b-button>
                <b-button size="sm" variant="outline-secondary" class="text-nowrap" :disabled="imgBusy" title="另存为新的发货人(새 발송인으로 저장)" @click="saveShipper(true)">另存(새로)</b-button>
                <b-button size="sm" variant="outline-danger" class="text-nowrap" :disabled="imgBusy || !shipperSaved" title="删除所选发货人(고른 발송인 삭제)" @click="deleteShipper">删除</b-button>
              </div>
              <input v-model="info.exporter.name" class="form-control form-control-sm mb-1" placeholder="Company">
              <input v-model="info.exporter.addr1" class="form-control form-control-sm mb-1" placeholder="Address 1">
              <input v-model="info.exporter.addr2" class="form-control form-control-sm mb-1" placeholder="Address 2">
            </div>
            <div class="col-md-4">
              <label class="small mb-0">收货人 Messrs(수입자 — {{ model.companyids.map(ownerText).join(', ') }})</label>
              <input v-model="importer.name" class="form-control form-control-sm mb-1" placeholder="Company">
              <input v-model="importer.addr1" class="form-control form-control-sm mb-1" placeholder="Address 1">
              <input v-model="importer.addr2" class="form-control form-control-sm mb-1" placeholder="Address 2">
              <div class="d-flex inv-gen__gap">
                <input v-model="importer.email" class="form-control form-control-sm" placeholder="E-MAIL">
                <input v-model="importer.tel" class="form-control form-control-sm" placeholder="TEL">
              </div>
            </div>
            <div class="col-md-4">
              <label class="small mb-0">日期(날짜) · 港口(항구)</label>
              <input type="date" v-model="info.date" class="form-control form-control-sm mb-1">
              <div class="d-flex inv-gen__gap mb-1">
                <select v-model="info.portLoading" class="form-control form-control-sm" title="Port of Loading">
                  <option v-for="o in portLoadingOptions" :key="o" :value="o">{{ o }}</option>
                </select>
                <select v-model="info.finalDest" class="form-control form-control-sm" title="Final Destination">
                  <option v-for="o in finalDestOptions" :key="o" :value="o">{{ o }}</option>
                </select>
              </div>
              <div class="d-flex inv-gen__gap mb-1">
                <input v-model="info.carrier" class="form-control form-control-sm" placeholder="Carrier">
                <input v-model="info.sailing" class="form-control form-control-sm" placeholder="Sailing on/or About">
              </div>
              <input v-model="info.remarks" class="form-control form-control-sm" placeholder="Remarks">
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap mt-2 inv-gen__gap small">
            <span>🔴 印章图片(도장)</span>
            <select v-model="sealId" class="form-control form-control-sm" style="width:200px" @change="loadSeal">
              <option value="">不使用(사용 안 함)</option>
              <option v-for="(sl, si) in sealOptions" :key="sl._id" :value="sl._id">{{ sl.label || ('印章' + (si + 1) + ' · ' + sl.name) }}</option>
            </select>
            <span v-if="images.seal" class="text-success">✓</span>
            <label class="btn btn-sm btn-outline-secondary mb-0">
              上传新印章(도장 추가)
              <input type="file" accept="image/png,image/jpeg" class="d-none" :disabled="imgBusy" @change="onSealFile">
            </label>
            <b-button v-if="sealId" size="sm" variant="link" class="p-0 text-danger" :disabled="imgBusy" @click="deleteSeal">删除印章(삭제)</b-button>
            <span class="ml-3">📄 营业执照图片(사업자등록증 — Sheet1)</span>
            <select v-model="licenseId" class="form-control form-control-sm" style="width:260px" @change="loadLicense">
              <option value="">不使用(사용 안 함)</option>
              <option v-for="l in licenseOptions" :key="'lc' + l._id" :value="l._id">{{ licenseText(l) }}</option>
            </select>
            <span v-if="images.license" class="text-success">✓ {{ images.license.name }}</span>
            <router-link :to="{ name: 'logis.invoicelicenses' }" target="_blank" class="btn btn-sm btn-outline-secondary">管理营业执照(사업자등록증 관리) ↗</router-link>
            <b-button size="sm" variant="link" class="p-0" :disabled="imgBusy" title="管理页面改了以后刷新(관리 화면에서 바꾼 뒤 새로고침)" @click="loadImageList">↻</b-button>
            <b-spinner v-if="imgBusy" small></b-spinner>
          </div>
        </b-card>

        <!-- ⑤-b 미리보기 -->
        <b-card class="mt-3" body-class="p-2">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2 inv-gen__gap">
            <span class="inv-gen__subh mb-0">👀 预览(미리보기) — 共 {{ totalQty }} PCS · ${{ totalAmount.toFixed(2) }} · {{ packageText }} · {{ totalGw.toFixed(2) }}kg · {{ totalCbm.toFixed(2) }}CBM</span>
            <b-button size="sm" variant="outline-primary" :disabled="!canDownload" @click="download">⬇ 下载箱单发票(엑셀 다운로드)</b-button>
          </div>
          <div class="d-flex align-items-center flex-wrap inv-gen__gap mb-2">
            <span v-if="!cooRequired" class="inv-gen__msg inv-gen__msg--info">ⓘ {{ cooNotNeededText }} — 总金额不足 ${{ cooMinUsd }}，H列(CO) 留空(총금액 ${{ cooMinUsd }} 미만이라 원산지증명 불필요 — H열은 비워 둡니다)</span>
            <span v-else class="inv-gen__msg" :class="cooDone ? 'inv-gen__msg--ok' : 'inv-gen__msg--info'">{{ cooDone ? '✓ H列(CO) 填产地证编号(원산지증명 번호가 들어갑니다)' : 'ⓘ H列(CO) 在生成产地证后才填写，先生成产地证再下载(원산지증명을 먼저 만들어야 H열 번호가 들어갑니다)' }}</span>
            <span v-if="recordMsg" class="inv-gen__msg" :class="recordErr ? 'inv-gen__msg--err' : 'inv-gen__msg--ok'">{{ recordErr ? '✕' : '✓' }} {{ recordMsg }}</span>
            <router-link :to="{ name: 'logis.invoicerecords' }" class="small">📑 箱单发票列表(서류 목록) →</router-link>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-bordered mb-0 inv-gen__preview">
              <thead class="thead-light">
                <tr>
                  <th>托盘号/箱号(Mark)</th><th>HS CODE</th><th>Description</th><th>Qty(PCS)</th><th>Unit Price</th><th>Amount</th>
                  <th>毛重 G/W(kg)</th><th>体积 CBM</th><th>尺寸(m)</th>
                </tr>
              </thead>
              <tbody>
                <!-- 散货 는 箱号 마다 한 묶음(PA 와 같다, 2026-10-04 YZY) — 박스별 毛重·体积 을 넣으면 托盘 합계가 따라간다 -->
                <template v-for="bl in previewBlocks">
                  <tr v-for="(it, ii) in bl.items" :key="bl.key + '-' + ii" :class="{ 'inv-gen__fixedrow': it.fixed }">
                    <td v-if="ii === 0" :rowspan="bl.items.length">{{ bl.mark }}<div class="small text-muted">{{ bl.sub }}</div>
                      <div v-if="plan && bl.p.planHit === false" class="small text-danger">⚠ 方数计划里没有(방수계획에 없음)</div></td>
                    <td class="text-nowrap">{{ it.hs }}</td>
                    <td>{{ it.desc }}</td>
                    <td class="text-right">{{ it.qty }}</td>
                    <td class="text-right">${{ it.price }}<small v-if="it.fixed" class="d-block text-dark" title="韩文标签资料 固定申报金额(고정 申报金额 사용 — 합포장도 ×N 안 함)">固定</small><small v-if="it.pack" class="d-block" :class="it.pack === '수정본' ? 'text-info' : 'text-warning'" :title="it.pack === '수정본' ? '직원이 고친 합포장 — 단가를 곱하지 않음' : '합포장 낱개 단가 × N 적용'">{{ it.pack }}</small></td>
                    <td class="text-right">${{ it.amount.toFixed(2) }}</td>
                    <!-- 毛重·体积 수정값 = volEdits(④ 세트 수정과 같은 값). 고친 칸은 파란 칸 + ↺ 자동값(2026-10-07 YZY) -->
                    <td v-if="ii === 0" :rowspan="bl.items.length">
                      <input type="number" step="0.01" min="0" :value="bl.t.gw" :class="['form-control form-control-sm', { 'is-invalid': !bl.t.gw, 'inv-gen__edited': gwEdited(bl) }]" placeholder="kg"
                        @change="editVol(mode, bl.p, bl.box ? bl.t.code : null, 'gw', $event.target.value)">
                      <a v-if="gwEdited(bl)" href="#" class="small text-nowrap" title="恢复自动值(자동값으로)" @click.prevent="editVol(mode, bl.p, bl.box ? bl.t.code : null, 'gw', '')">↺ {{ bl.box ? bl.t.autoGw : bl.p.auto.gw }}</a>
                    </td>
                    <!-- 散货 体积 은 그 散货 箱号 줄 전체를 합친 한 칸 = 총 방수(2026-10-04 YZY) -->
                    <td v-if="ii === 0 && (!bl.box || bl.groupFirst)" :rowspan="bl.box ? bl.groupRows : bl.items.length">
                      <input type="number" step="0.01" min="0" :value="bl.p.cbm" :class="['form-control form-control-sm', { 'is-invalid': !bl.p.cbm, 'inv-gen__edited': !!(bl.p.volEdit && bl.p.volEdit.cbm) }]" placeholder="CBM"
                        @change="editVol(mode, bl.p, null, 'cbm', $event.target.value)">
                      <a v-if="bl.p.volEdit && bl.p.volEdit.cbm" href="#" class="small text-nowrap" title="恢复自动值(자동값으로)" @click.prevent="editVol(mode, bl.p, null, 'cbm', '')">↺ {{ bl.p.auto.cbm }}</a>
                    </td>
                    <td v-if="ii === 0" :rowspan="bl.items.length"><input type="text" v-model.trim="bl.t.dims" class="form-control form-control-sm" placeholder="m"></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <details class="inv-gen__help mt-2">
            <summary>ⓘ 说明(도움말)</summary>
            毛重·体积默认取自「箱子大小」/方数计划，可修改(改过的格子显示蓝色，↺ 恢复自动值；只改单据，不改出库清单)；散货按每个箱号一行填毛重，体积合并为一格(散货总方数)(G/W·CBM 은 箱子大小·방수계획에서 가져온 값이며 고칠 수 있습니다. 散货 는 箱号 마다 한 줄 — 毛重 은 박스별, 体积 은 散货 전체 한 칸).
          </details>
        </b-card>

        <!-- ⑤-c 产地证(원산지증명서) -->
        <b-card class="mt-3" body-class="p-2">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2 inv-gen__gap">
            <span class="inv-gen__subh mb-0">📜 生成产地证(원산지증명서) — {{ cooItems.length }} 个商品(품목)<template v-if="cooMergedRows">(同品名+HS编码 {{ cooMergedRows }}行已合并 · 같은 품명+HS {{ cooMergedRows }}줄 합침)</template> · 每个文件最多 {{ cooMax }} 个(파일당 최대 {{ cooMax }}품목)</span>
            <b-button v-if="cooRequired" size="sm" variant="outline-primary" :disabled="!canDownloadCoo" @click="downloadCoo">
              ⬇ 下载产地证(원산지증명 다운로드) · {{ cooFiles.length }} 个文件(파일)
            </b-button>
          </div>
          <!-- 箱单发票 총금액 230 USD 미만 = 产地证 안 만든다(2026-10-07 YZY). 生成 버튼은 숨긴다 -->
          <div v-if="!cooRequired" class="alert alert-warning py-2 mb-2 font-weight-bold">
            {{ cooNotNeededText }} — 箱单发票总金额 ${{ totalAmount.toFixed(2) }} &lt; ${{ cooMinUsd }}(인보이스 총금액이 ${{ cooMinUsd }} 미만이라 원산지증명이 필요 없습니다)
          </div>
          <div class="form-row mb-2">
            <div class="col-md-7">
              <label class="small mb-0">产地证出口商 Exporter(1번 칸 수출자 — 비우면 위 发货人)</label>
              <textarea v-model="cooInfo.exporter" rows="2" class="form-control form-control-sm" :placeholder="'空 = 使用上面的发货人(비우면 위 发货人)'"></textarea>
            </div>
            <div class="col-md-5">
              <label class="small mb-0">船名航次 Vessel/Voyage(선명/항차 — 비우면 위 Carrier)</label>
              <input v-model.trim="cooInfo.vessel" class="form-control form-control-sm" placeholder="VESSEL NAME/VOYAGE">
            </div>
          </div>
          <div class="d-flex flex-wrap align-items-center inv-gen__gap small mb-1">
            <span>全部设为(전체 지정):</span>
            <b-button v-for="t in cooTypes" :key="'all' + t.code" size="sm" variant="outline-secondary" @click="setAllCoo(t.code)">{{ t.label }}</b-button>
            <span class="text-muted">文件(파일): {{ cooFileSummary || '-' }}</span>
          </div>
          <div class="table-responsive inv-gen__coo">
            <table class="table table-sm table-bordered mb-0 inv-gen__preview">
              <thead class="thead-light">
                <tr><th>HS(6位)</th><th>品名 Description</th><th>数量(수량)</th><th style="width:300px">产地证种类(원산지증명 종류)</th></tr>
              </thead>
              <tbody>
                <tr v-for="g in cooHsGroups" :key="'hs' + g.hs">
                  <td class="text-nowrap" :class="{ 'text-danger': !g.hs }">{{ g.hs || '无HS(HS 없음)' }}</td>
                  <td>{{ g.descs.join(' / ') }}</td>
                  <td class="text-right">{{ g.qty }}</td>
                  <td>
                    <select class="form-control form-control-sm" :value="cooTypeOf(g.hs)" @change="setCoo(g.hs, $event.target.value)">
                      <option v-for="t in cooTypes" :key="t.code" :value="t.code">{{ t.label }}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <details class="inv-gen__help mt-2">
            <summary>ⓘ 说明(도움말)</summary>
            按HS编码选择种类，下次同一HS自动沿用(HS코드별로 종류를 고르면 이 브라우저가 기억해 다음에도 같은 종류로 나옵니다). 超过{{ cooMax }}个商品自动分成多个文件(-1、-2…)，多个文件打包成zip(여러 파일은 zip 하나로 받습니다).
          </details>
        </b-card>
      </template>
    </template>
      </template>
    </section>

    <!-- 单独上传 직후 收件人信息 입력(2026-10-06 YZY) — 营业执照管理 의 수취정보 칸과 같다 -->
    <b-modal v-model="rcpt.show" size="lg" no-close-on-backdrop :title="'填写收件人信息(수취인 정보 입력) — ' + rcpt.co">
      <div class="small text-muted mb-2">{{ rcpt.licenseText }}</div>
      <div class="form-group mb-2">
        <label class="small mb-0">收件人 Consignee(수취인 이름 — 箱单发票 收货人)</label>
        <input v-model="rcpt.recipient" class="form-control form-control-sm" placeholder="Company name (English)">
      </div>
      <div class="form-group mb-2">
        <label class="small mb-0">地址 Address(영문 주소)</label>
        <textarea v-model="rcpt.addrEn" rows="2" class="form-control form-control-sm" placeholder="Address (English)"></textarea>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <label class="small mb-0">邮箱 E-MAIL</label>
          <input v-model="rcpt.email" class="form-control form-control-sm" placeholder="E-MAIL">
        </div>
        <div class="col-md-6">
          <label class="small mb-0">电话 TEL</label>
          <input v-model="rcpt.tel" class="form-control form-control-sm" placeholder="TEL">
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="outline-secondary" :disabled="rcpt.saving" @click="rcpt.show = false">稍后填写(나중에)</b-button>
        <b-button size="sm" variant="primary" :disabled="rcpt.saving || !rcpt.recipient.trim()" @click="saveRecipient">
          <b-spinner v-if="rcpt.saving" small></b-spinner> 保存(저장)
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import { parseWarehouseList, detectMode } from './warehouseListParser';
import { withBarcodeRows, barcodeRowsWarnings } from './invoiceBarcodeRows';
import { stripXlsxMedia, u8ToBinaryString } from './warehouseXlsxSlim';
import {
  listPallets, buildInvoiceModel, packageCountText, invoiceFileName, writeInvoiceXlsx, palletMark, hasBoxRows, parseVolumePlan, applyVolumePlan, INTEGRATED_OWNER,
  INTEGRATED_RECIPIENTS, setOwnerAll, mergeAoa, listHeaderProblems, listMissingCols, comparePalletId, readPlanBreaks, splitByPlanBlocks, planHasBlocks, splitByOwner, coupassSeparateOwners, planKey, batchDocBase,
  markAutoVolume, restoreAutoVolume, volumeWithEdit, applyVolumeEdit, splitTotal, splitPalletKg
} from './invoiceXlsx';
import { shrinkImage, licenseText } from './invoiceImage';
import { planAutoMerge } from './ownerAutoMerge';
import { COO_TYPES, COO_CHOICES, COO_NONE_CODE, cooChoice, COO_MAX_ITEMS, COO_MIN_USD, COO_NOT_NEEDED_TEXT, invoiceAmount, cooNeeded, cooItems, splitCooFiles, writeCooXlsx, cooFileName, batchCooFileName, zipFiles, zipFilesUtf8, cooInvoiceNo } from './cooXlsx';
import { OUT_HEADER, buildOutRows, buildBoxes, coRefOf, compareBl, CUSTOMS_SLOT, dateFromName, outboundListSlot } from './invoiceRecord';

// 수출자·항구 기본값 = 창고가 실제로 쓰는 箱单发票 샘플(2026-10 YZY). 화면에서 고치면 이 브라우저에 남는다.
const DEFAULT_INFO = {
  exporter: {
    name: 'Weihai Xingmao International Trade Co., Ltd',
    addr1: 'Area A-1, No. 9-1, Hainan Road, Fenglin Street, Weihai Economic and Technological',
    addr2: 'Development Zone,Shandong Province, CHINA'
  },
  portLoading: 'SHIDAO CHINA',
  finalDest: 'KUNSAN KOREA',
  carrier: '',
  sailing: '',
  notify: '',
  remarks: ''
};
const LS_INFO = 'coupass.invoice.info';
// 항구는 고르기만(2026-10-04 YZY) — 첫 값이 기본. 이 브라우저에 옛 값(GUNSAN 등)이 남아 있으면 기본으로 돌린다
const PORT_LOADING = ['SHIDAO CHINA', 'YANTAI CHINA'];
const FINAL_DEST = ['KUNSAN KOREA', 'INCHON KOREA'];
const LS_PICK = 'coupass.invoice.pick'; // 마지막에 고른 发货人·印章 id
const SHIPPER_DEFAULT = 'shipper:default'; // DB 에 없으면 코드의 DEFAULT_INFO.exporter 를 보여준다(시드 없음)
// 营业执照 화주 ↔ 출고리스트 L열 화주 — 대소문자·공백 무시(등록 「HARU」 ↔ L열 「Haru」, 2026-10-07 YZY)
const coKey = v => String(v || '').replace(/\s/g, '').toLowerCase();
const sameCo = (a, b) => !!coKey(a) && coKey(a) === coKey(b);
// 영문 주소 한 줄 → 收货人 Address 1·2 두 줄. 줄바꿈이 있으면 그대로, 길면 가운데 가까운 쉼표에서 나눈다
function splitAddress(s) {
  const lines = String(s || '').split(/\n/).map(x => x.trim()).filter(Boolean);
  if (lines.length > 1) return [lines[0], lines.slice(1).join(', ')];
  const one = lines[0] || '';
  if (one.length <= 60) return [one, ''];
  const commas = [];
  for (let i = 0; i < one.length; i++) if (one[i] === ',') commas.push(i);
  if (!commas.length) return [one, ''];
  const cut = commas.reduce((a, b) => (Math.abs(b - one.length / 2) < Math.abs(a - one.length / 2) ? b : a));
  return [one.slice(0, cut + 1).trim(), one.slice(cut + 1).trim()];
}
const LS_IMPORTER = 'coupass.invoice.importer.';
const LS_COO_INFO = 'coupass.coo.info';
const LS_SAVED_OPEN = 'coupass.invoice.savedOpen'; // ② 저장된 출고리스트 목록 펼침 여부
const LS_COO_TYPE = 'coupass.coo.typeByHs'; // HS 6자리 → FCN1/E1/FRCCN1 (출고리스트엔 종류가 없어 화면에서 고른 값을 기억)
const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
// 营业执照·印章 은 서버(DB)에 한 번 등록해 두고 계속 쓴다(/api/coupassInvoiceImage/*). 올리기 전에 브라우저에서 줄인다.
// 营业执照 등록·관리는 별도 화면(InvoiceLicenseList.vue) — 화주 한 명에 여러 장(2026-10-04 YZY). 여기선 고르기만 한다.

function b64ToU8(b64) {
  const bin = atob(b64);
  const u8 = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
  return u8;
}
function lsGet(key) {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  } catch (e) {
    console.error('인보이스 설정 읽기 실패:', e);
    return null;
  }
}
function lsSet(key, val) {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch (e) {
    console.error('인보이스 설정 저장 실패:', e);
  }
}
function today() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
// 方数计划 날짜 = 창고(중국) 날짜. 브라우저 시간대와 상관없이 UTC+8 로 센다
function chinaToday() {
  return new Date(Date.now() + 8 * 3600 * 1000).toISOString().slice(0, 10);
}
// block = 方数计划 굵은 테두리 묶음 번호(综合清关 세트 단위) — 옛 계획표엔 없다
const planToRows = plan => [...plan].map(([id, v]) => Object.assign({ id, dims: v.dims, cbm: v.cbm }, v.block === undefined ? {} : { block: v.block }));
const rowsToPlan = rows => new Map((rows || []).map(r => [r.id, Object.assign({ dims: r.dims || '', cbm: Number(r.cbm) || 0 }, Number.isInteger(r.block) ? { block: r.block } : {})]));
const BLANK_IMPORTER = { name: '', addr1: '', addr2: '', email: '', tel: '' };
const CUSTOMS_LABEL = { integrated: '综合清关', client: '单独清关', kupass: 'COUPASS单独清关' };
// 收货人 = 营业执照 의 수취정보(营业执照管理 에서 적은 값). 있는 칸만 덮는다 — 비어 있는 칸은 base(이 브라우저에 적어 둔 값) 그대로. 收件人 이 비면 영문상호명
function consigneeFrom(doc, base) {
  const next = Object.assign({}, BLANK_IMPORTER, base || {});
  if (!doc) return next;
  const t = v => String(v || '').trim();
  const name = t(doc.recipient) || t(doc.labelEn);
  const lines = splitAddress(t(doc.addrEn));
  if (name) next.name = name;
  if (lines[0]) { next.addr1 = lines[0]; next.addr2 = lines[1] || ''; }
  if (t(doc.email)) next.email = t(doc.email);
  if (t(doc.tel)) next.tel = t(doc.tel);
  return next;
}
export default {
  name: 'InvoiceGenerator',
  props: {
    // 출고리스트 저장·자동 출고(warehouseManagement.saveOutboundFromInvoice) — (files, date) => 결과 문구. 없으면 예전처럼 브라우저에서만 읽는다
    saveOutbound: { type: Function, default: null },
    // 출고리스트 저장본 파일 삭제(warehouseManagement.deleteOutFile — 待出库 의 「删除文件」 그대로: 확인창·출고 취소·일부 출고 유지). (f) => 실행했으면 true
    deleteOutbound: { type: Function, default: null }
  },
  data() {
    const saved = lsGet(LS_INFO) || {};
    return {
      busy: false,
      error: '',
      // 출고리스트 두 칸(2026-10-06 YZY) — integrated = 综合清关(여러 파일 합침, 전체가 수취인 명의), separate = 单独清关(L열 화주별)
      uploadKinds: [
        { key: 'integrated', label: '综合清关出库列表上传(통합통관 출고리스트)' },
        { key: 'separate', label: '单独清关出库列表上传(단독통관 출고리스트)' }
      ],
      modeOptions: [{ value: 'integrated', text: '综合清关(통합)' }, { value: 'separate', text: '单独清关(단독)' }],
      lists: { integrated: null, separate: null }, // { names, aoa, parsed, palletCount } — 표 아래(托盘号 선택)는 mode 쪽을 보여준다
      mode: 'integrated',
      recipients: INTEGRATED_RECIPIENTS,
      integratedTo: INTEGRATED_RECIPIENTS[0].id,
      batchBusy: false,
      batchMsg: '',
      batchErr: false,
      fileName: '',
      aoa: null,
      parsed: null,
      pallets: [],
      companyFilter: '',
      palletFilter: [],
      selected: [],
      model: null,
      info: Object.assign({}, DEFAULT_INFO, saved, {
        exporter: Object.assign({}, DEFAULT_INFO.exporter, saved.exporter || {}),
        portLoading: PORT_LOADING.includes(saved.portLoading) ? saved.portLoading : PORT_LOADING[0],
        finalDest: FINAL_DEST.includes(saved.finalDest) ? saved.finalDest : FINAL_DEST[0],
        date: today()
      }),
      portLoadingOptions: PORT_LOADING,
      finalDestOptions: FINAL_DEST,
      shipperId: (lsGet(LS_PICK) || {}).shipperId || SHIPPER_DEFAULT,
      sealId: (lsGet(LS_PICK) || { sealId: 'seal' }).sealId || '',
      importer: { name: '', addr1: '', addr2: '', email: '', tel: '' },
      images: { seal: null, license: null },
      imgBusy: false,
      imageList: [],
      licenseId: '',
      plan: null, // 方数计划 — 托盘号 → { dims, cbm } (서버에 날짜별로 저장된 것)
      planName: '',
      planBy: '',
      planDate: chinaToday(),
      planBusy: false,
      cooTypes: COO_TYPES,
      cooChoices: COO_CHOICES, // 세트·화주 드롭다운 = 3종 + 无需做产地证(2026-10-08 YZY)
      cooMax: COO_MAX_ITEMS,
      cooMinUsd: COO_MIN_USD,
      cooNotNeededText: COO_NOT_NEEDED_TEXT,
      cooNoneCode: COO_NONE_CODE,
      cooInfo: { exporter: (lsGet(LS_COO_INFO) || {}).exporter || '', vessel: '' },
      cooTypeByHs: lsGet(LS_COO_TYPE) || {},
      // 마지막으로 내려받은 产地证 의 모양 — 지금 화면과 같을 때만 箱单发票 H 열에 CO 번호를 넣는다
      cooDoneSig: '',
      recordMsg: '',
      recordErr: false,
      ownerLicense: {}, // 单独清关 화주 → 고른 营业执照 id(여러 장일 때)
      fixedMap: {}, // 韩文标签资料 의 고정 申报金额 — 「화주|바코드」→USD(2026-10-11 YZY). 새로 만들 때만 적용, 이미 만든 기록은 그대로
      namesMap: {}, // 韩文标签资料 의 확정 영문 품명 — 「화주|바코드」→품명(2026-10-16 YZY #27). fixedMap 과 같은 호출로 읽는다
      fixedErr: '',
      packOff: { integrated: false, separate: false }, // 合包 申报单价 ×N 자동 계산 끄기 — 직원이 이미 ×N 으로 고쳐 올린 출고리스트용(칸별, 2026-10-08)
      autoOwnerMerge: {}, // 同一营业执照 자동 합치기(2026-10-08 YZY) — { 합쳐진 화주: 대표 화주 }. 직원이 손으로 합친 ownerMerge 가 우선
      autoOwnerLic: {}, // { 자동 대표 화주: 营业执照 id }
      autoMergeOff: {}, // 해제한 营业执照 id — 이 화면 안에서 다시 자동으로 합치지 않는다
      ownerMerge: {}, // 单独清关 화주 합치기(2026-10-07 YZY) — 원래 화주 → 대표 화주. 이 화면 안에서만(해제 가능)
      mergePick: [], // 합칠 화주 체크
      mergeRep: '', // 대표 화주
      setRecipient: {}, // 일괄 생성 综合清关 세트(i:첫 托盘号) → 收货人(INTEGRATED_RECIPIENTS id). 없으면 integratedTo(2026-10-06 YZY)
      licOpen: '', // ③ 营业执照 검색 목록이 열린 화주
      licQuery: '',
      setCooType: {}, // 일괄 생성 세트 → 产地证 종류(o:화주 / i:첫 托盘号). 없으면 韩中FTA(FCN1)
      singleOpen: false, // ⑤ 托盘号 한 건씩 — 평소 접어 둔다(2026-10-06 YZY)
      rcpt: { show: false, id: '', co: '', licenseText: '', recipient: '', addrEn: '', email: '', tel: '', saving: false }, // 收件人信息 입력 창
      // 출고리스트 저장본(待出库 탭에서 그 날짜로 올린 것) — 파일마다 { fileName, aoa, rows }(얼림), savedSlot = 파일 → integrated|separate|''(안 씀)
      savedFiles: [],
      savedOpen: lsGet(LS_SAVED_OPEN) === true, // 저장본 목록 펼침 — 기본 접힘(2026-10-07 YZY)
      savedSlot: {},
      savedBusy: false,
      slotHint: {}, // 이 화면에서 올린 파일의 칸(综合/单独) — 저장본을 다시 읽을 때 고른 칸 그대로
      saveMsg: '',
      saveBusy: false,
      savedDeleting: '', // 지우는 중인 저장본 파일명
      // 부피·중량 수동 수정(2026-10-07 YZY) — '칸(integrated|separate)|托盘号' → { gw, cbm, boxes: { 箱号: 毛重 } }. 서류에만 쓴다(원본 출고리스트는 그대로).
      // 서류 기록에 남은 수정값을 날짜를 열 때 다시 읽어 온다(loadVolEdits)
      volEdits: {},
      volOpen: {} // ④ 세트 → 托盘 명세(수정 칸) 펼침
    };
  },
  computed: {
    // 접어 둔 저장본 목록에서도 「칸과 다름」 파일 수는 제목 줄에 보인다
    savedConflictCount() {
      return this.savedFiles.filter(f => this.savedConflict(f).length).length;
    },
    companyOptions() {
      const set = new Set();
      this.pallets.forEach(p => p.companyids.forEach(c => set.add(c)));
      return [...set].sort();
    },
    palletOptions() {
      const co = this.companyFilter;
      return this.pallets.filter(p => !co || p.companyids.includes(co)).map(p => p.id);
    },
    filteredPallets() {
      const co = this.companyFilter;
      const ids = this.palletFilter;
      return this.pallets.filter(p => (!co || p.companyids.includes(co)) && (!ids.length || ids.includes(p.id)));
    },
    palletFilterText() {
      const n = this.palletFilter.length;
      if (!n) return '全部托盘号(파렛트 전체)';
      return n === 1 ? this.palletFilter[0] : '托盘号 ' + n + '个(파렛트 ' + n + '개)';
    },
    allFilteredSelected() {
      return this.filteredPallets.length > 0 && this.filteredPallets.every(p => this.selected.includes(p.id));
    },
    licenseList() { return this.imageList.filter(x => x.kind === 'license'); },
    // 印章 — 처음 한 장('seal')이 맨 앞
    sealOptions() { return this.imageList.filter(x => x.kind === 'seal').sort((a, b) => (a._id === 'seal' ? -1 : b._id === 'seal' ? 1 : (a._id < b._id ? -1 : 1))); },
    // 发货人 — 기본(Weihai Xingmao)이 맨 앞. DB 에 기본을 고쳐 저장한 게 없으면 코드의 기본값
    shipperOptions() {
      const saved = this.imageList.filter(x => x.kind === 'shipper');
      const def = saved.find(x => x._id === SHIPPER_DEFAULT) || Object.assign({ _id: SHIPPER_DEFAULT, sealId: 'seal', builtin: true }, DEFAULT_INFO.exporter);
      return [def].concat(saved.filter(x => x._id !== SHIPPER_DEFAULT).sort((a, b) => (a._id < b._id ? -1 : 1)));
    },
    shipperSaved() { return this.imageList.some(x => x.kind === 'shipper' && x._id === this.shipperId); },
    // 고를 수 있는 营业执照 — 화주가 정해졌으면 그 화주 것만(한 화주에 여러 장), 아니면 전부
    licenseOptions() {
      const co = this.currentCompany();
      const opts = this.licenseOptionsFor(co);
      // 单独清关 인데 표에 「COUPASS单独清关」 이 적힌 화주 — COUPASS 营业执照 를 맨 앞(자동 선택)에
      const cp = this.mode === 'separate' && this.coupassSepOwners.has(co) ? this.coupassLicense : null;
      return cp && !opts.includes(cp) ? [cp].concat(opts) : opts;
    },
    // 单独清关 표에서 「COUPASS单独清关」류 글자가 나온 화주(2026-10-07 YZY)
    coupassSepOwners() {
      const ls = this.lists.separate;
      return ls ? coupassSeparateOwners(ls.aoa, ls.parsed) : new Set();
    },
    coupassLicense() { return this.fixedLicenses.find(l => sameCo(l.companyid, INTEGRATED_OWNER)) || null; },
    // 일괄 생성 — 综合清关 은 方数计划 굵은 테두리 칸마다, 单独清关 은 L열 화주마다 한 세트(2026-10-06 YZY)
    batchViews() {
      const out = [];
      const li = this.lists.integrated;
      if (li) {
        let blocker = '';
        if (!this.plan) blocker = '先上传当天方数计划(이 날짜 방수계획을 먼저 올려 주세요)';
        else if (!planHasBlocks(this.plan)) blocker = '方数计划没有粗框分组信息，请重新上传方数计划(굵은 테두리 정보가 없는 옛 업로드 — 방수계획을 다시 올려 주세요)';
        const ids = listPallets(li.parsed).map(p => p.id);
        const sets = blocker ? [] : splitByPlanBlocks(ids, this.plan).map(s => Object.assign(s, {
          title: s.missing ? '方数计划里没有(계획표에 없음)' : s.ids[0] + (s.ids.length > 1 ? ' ~ ' + s.ids[s.ids.length - 1] : ''),
          cooKey: 'i:' + (s.missing ? 'missing' : s.ids[0]) // 产地证 종류 — 세트 첫 托盘号 로 기억
        }));
        // 순번 = 方数计划 굵은 테두리 순서(splitByPlanBlocks 가 묶음 순서로 준다) — 파일명·zip·서류 목록 순서(2026-10-06 YZY)
        // 收货人 = 세트마다 고른 값(기본 integratedTo) — 파일명 앞부분 「INVOICE_<수취인>-날짜-순번」(2026-10-06 YZY)
        sets.forEach((s, i) => {
          s.seq = i + 1;
          s.rcpt = this.setRecipientOf(s.cooKey);
          const rc = INTEGRATED_RECIPIENTS.find(x => x.id === s.rcpt);
          s.docBase = batchDocBase((rc && rc.file) || s.rcpt, this.planDate, s.seq, s.ids);
          s.vol = this.setVolume('integrated', s);
          s.amount = invoiceAmount({ pallets: s.vol.rows.map(r => r.p) }); // 箱单发票 총금액(USD) — 230 미만이면 产地证 없음
        });
        out.push({ key: 'integrated', label: '综合清关 → ' + this.integratedWho(sets), sets, blocker });
      }
      const ls = this.lists.separate;
      if (ls) {
        // 单独清关 도 方数计划 에서 그 화주 托盘 이 처음 나오는 묶음 순서로, 번호는 综合清关 다음부터 이어서
        const first = out.length ? out[0].sets.length : 0;
        const blockOf = s => Math.min(...s.ids.map(id => { const v = this.plan && this.plan.get(planKey(id)); return v && v.block !== undefined ? v.block : Infinity; }), Infinity);
        const sets = splitByOwner(ls.parsed)
          .map(s => Object.assign(s, { title: s.members.length > 1 ? s.co + '(合并 ' + s.members.join('+') + ')' : s.co, cooKey: 'o:' + s.co, order: blockOf(s) }))
          .sort((a, b) => (a.order === b.order ? a.co.localeCompare(b.co) : a.order < b.order ? -1 : 1));
        sets.forEach((s, i) => { s.seq = first + i + 1; s.docBase = batchDocBase(s.co, this.planDate, s.seq, s.ids); s.vol = this.setVolume('separate', s); s.amount = invoiceAmount({ pallets: s.vol.rows.map(r => r.p) }); });
        const note = out.length && !out[0].blocker ? '' : '综合清关未上传或未就绪，序号从1开始(통합통관이 없거나 준비 전이라 번호가 1부터 시작합니다 — 통합통관을 먼저 올리면 이어서 번호가 붙습니다)';
        out.push({ key: 'separate', label: '单独清关 → 按货主(화주별)', sets, blocker: '', note });
      }
      return out;
    },
    // ④ 세트 합계용 托盘 자동값(출고리스트·方数计划, 2026-10-07 YZY) — 칸마다 한 번 만들어 둔다(일괄 생성과 같은 단위: 单独清关 은 화주별).
    // 키 = 托盘号, 单独清关 은 '화주|托盘号'. 수정값은 여기에 덮지 않고 setVolume 이 계산만 한다
    autoPallets() {
      const out = {};
      ['integrated', 'separate'].forEach(key => {
        const l = this.lists[key];
        if (!l) return;
        const map = new Map();
        const groups = key === 'separate'
          ? splitByOwner(l.parsed).map(s => ({ pre: s.co + '|', parsed: s.parsed, ids: s.ids }))
          : [{ pre: '', parsed: l.parsed, ids: listPallets(l.parsed).map(p => p.id) }];
        groups.forEach(g => {
          try {
            buildInvoiceModel(l.aoa, g.parsed, g.ids, { pack: !this.packOff[key], fixed: this.fixedMap, names: this.namesMap }).pallets.forEach(p => {
              if (this.plan) applyVolumePlan(p, this.plan);
              markAutoVolume(p);
              map.set(g.pre + p.id, p);
            });
          } catch (err) {
            console.error('세트 부피·중량 계산 실패:', err);
          }
        });
        out[key] = map;
      });
      return out;
    },
    // 수동 변경 목록에 넣는 고정 수취인(COUPASS 등) 营业执照
    fixedLicenses() {
      const ids = INTEGRATED_RECIPIENTS.map(x => x.id);
      return this.licenseList.filter(l => ids.includes(String(l.companyid || '').toLowerCase()))
        .sort((a, b) => ids.indexOf(String(a.companyid).toLowerCase()) - ids.indexOf(String(b.companyid).toLowerCase()));
    },
    // 单独清关 화주별 收货人 매칭(2026-10-06 YZY) — 营业执照 0장 = 올리기, 1장 = 자동, 여러 장 = 고르기(기본 첫 장)
    ownerMatches() {
      const ls = this.lists.separate;
      if (!ls) return [];
      return splitByOwner(ls.parsed).map(s => {
        const o = this.ownerLicenseOf(s.co);
        return { co: s.co, members: s.members, ids: s.ids, options: o.options, groups: o.groups, picked: o.picked, byKeyword: o.byKeyword, license: o.license, licenseId: o.license ? o.license._id : '', fixed: o.fixed, clearanceLabel: o.clearanceLabel, consignee: consigneeFrom(o.license, null) };
      });
    },
    items() {
      return this.model ? [].concat(...this.model.pallets.map(p => p.items)) : [];
    },
    totalQty() { return this.items.reduce((s, it) => s + it.qty, 0); },
    totalAmount() { return invoiceAmount(this.model); },
    // 箱单发票 총금액 230 USD 미만 = 产地证 안 만든다(2026-10-07 YZY)
    cooRequired() { return cooNeeded(this.totalAmount); },
    // 고정 申报金额를 쓴 품목 줄 수 — 화면 위 안내(2026-10-11 YZY)
    fixedRowCount() { return ((this.model && this.model.pallets) || []).reduce((n, p) => n + (p.items || []).filter(it => it.fixed).length, 0); },
    // 미리보기 묶음 — 托盘 하나, 散货 는 박스 하나씩. t = 毛重·体积·尺寸 을 고치는 대상(托盘 또는 박스)
    previewBlocks() {
      const out = [];
      ((this.model && this.model.pallets) || []).forEach(p => {
        if (hasBoxRows(p)) {
          // groupRows = 이 散货 의 箱号 줄 전체 행 수 — 体积 한 칸이 세로로 걸친다
          const groupRows = p.boxes.reduce((s, b) => s + b.items.length, 0);
          let first = true;
          p.boxes.forEach((b, bi) => {
            if (!b.items.length) return;
            out.push({ key: p.id + '#' + bi, p, box: true, mark: b.code, sub: p.id + ' · ' + (bi + 1) + '/' + p.boxes.length + 'BOX', items: b.items, t: b, groupFirst: first, groupRows });
            first = false;
          });
        } else {
          out.push({ key: p.id, p, box: false, mark: palletMark(p), sub: (p.kind === 'BOX' ? p.id + ' · ' : '') + p.count + p.kind, items: p.items, t: p });
        }
      });
      return out;
    },
    planMissing() { return this.plan && this.model ? this.model.pallets.filter(p => p.planHit === false).map(p => p.id) : []; },
    totalGw() { return this.model ? this.model.pallets.reduce((s, p) => s + (Number(p.gw) || 0), 0) : 0; },
    totalCbm() { return this.model ? this.model.pallets.reduce((s, p) => s + (Number(p.cbm) || 0), 0) : 0; },
    packageText() { return this.model ? packageCountText(this.model.pallets) : ''; },
    canDownload() {
      return !!(this.model && this.model.pallets.length && this.items.length && this.model.companyids.length === 1);
    },
    cooItems() { return this.model ? cooItems(this.model) : []; },
    cooMergedRows() { return this.cooItems.reduce((n, it) => n + (it.rows || 1), 0) - this.cooItems.length; },
    // 종류는 HS 6자리 단위로 고른다 — 같은 HS 품목은 같은 종류
    cooHsGroups() {
      const map = new Map();
      this.cooItems.forEach(it => {
        if (!map.has(it.hs)) map.set(it.hs, { hs: it.hs, descs: [], qty: 0 });
        const g = map.get(it.hs);
        if (!g.descs.includes(it.desc)) g.descs.push(it.desc);
        g.qty += it.qty;
      });
      return [...map.values()].sort((a, b) => a.hs.localeCompare(b.hs));
    },
    cooFiles() { return splitCooFiles(this.cooItems, hs => this.cooTypeOf(hs)); },
    cooFileSummary() {
      return COO_TYPES.map(t => {
        const list = this.cooFiles.filter(f => f.type === t.code);
        if (!list.length) return '';
        return t.label + ' ' + list.reduce((s, f) => s + f.items.length, 0) + '个商品→' + list.length + '个文件';
      }).filter(Boolean).join(' · ');
    },
    exporterPlaceholder() {
      const e = this.info.exporter;
      return [e.name, [e.addr1, e.addr2].filter(Boolean).join(' ')].filter(Boolean).join('\n');
    },
    canDownloadCoo() { return this.canDownload && this.cooRequired && this.cooFiles.length > 0; },
    cooSig() {
      return JSON.stringify([this.model && this.model.pallets.map(p => p.id), this.cooFiles.map(f => [f.type, f.items.map(it => [it.desc, it.hs, it.qty])])]);
    },
    cooDone() { return !!this.cooDoneSig && this.cooDoneSig === this.cooSig; }
  },
  mounted() {
    this.loadImageList();
    this.loadSeal();
    this.loadPlan();
    this.loadSaved();
    this.loadVolEdits();
  },
  watch: {
    selected() { this.rebuild(); },
    planDate() { this.loadPlan(); this.loadSaved(); this.loadVolEdits(); },
    // 부피·중량 수정값이 바뀌면(④ 세트·托盘 또는 ⑤) ⑤ 미리보기 托盘 에 다시 덮는다
    volEdits: { deep: true, handler() { this.applyVolEditsToModel(); } },
    // 综合清关 수취인을 바꾸면 전체 행의 货主 를 바꾸고 표·미리보기를 다시 만든다
    integratedTo(co) {
      const l = this.lists.integrated;
      if (!l) return;
      setOwnerAll(l.parsed, co);
      if (this.mode !== 'integrated') return;
      this.pallets = this.sortedPallets(l.parsed);
      this.rebuild();
    },
    companyFilter() {
      this.palletFilter = this.palletFilter.filter(id => this.palletOptions.includes(id));
    },
    info: {
      deep: true,
      handler(v) {
        lsSet(LS_INFO, { exporter: v.exporter, portLoading: v.portLoading, finalDest: v.finalDest, carrier: v.carrier, notify: v.notify });
      }
    },
    'cooInfo.exporter'(v) { lsSet(LS_COO_INFO, { exporter: v }); },
    importer: {
      deep: true,
      handler(v) {
        const co = this.model && this.model.companyids.length === 1 ? this.model.companyids[0] : '';
        if (co) lsSet(LS_IMPORTER + co, v);
      }
    }
  },
  methods: {
    readAoa(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            // 창고 파일엔 상품 사진이 박혀 와서 통째로 펼치면 브라우저가 멈춘다 — 출고완료 처리와 같은 방식으로 표만 읽는다
            const u8 = new Uint8Array(e.target.result);
            const slim = stripXlsxMedia(u8);
            const wb = XLSX.read(u8ToBinaryString(slim.out), { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]];
            resolve(XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: null }));
          } catch (err) { reject(err); }
        };
        reader.onerror = () => reject(new Error('文件读取失败(파일을 읽지 못했습니다)'));
        reader.readAsArrayBuffer(file);
      });
    },
    // 출고리스트 올리기 — key = integrated(综合清关) / separate(单独清关). 이미 올린 파일에 더해 한 표로 합친다(같은 이름은 교체, 2026-10-06 YZY)
    async onFiles(e, key) {
      const files = [...((e.target && e.target.files) || [])];
      if (e.target) e.target.value = ''; // 같은 파일을 다시 골라도 change 가 오게
      if (!files.length) return;
      this.busy = true;
      this.error = '';
      this.batchMsg = '';
      try {
        const list = [];
        for (const f of files) list.push({ name: f.name, aoa: await this.readAoa(f) });
        const bad = list.filter(x => detectMode((x.aoa && x.aoa[0]) || []) !== 'export').map(x => x.name);
        if (bad.length) {
          this.error = '不是出库清单(출고리스트가 아닙니다) — 10번 칸이 출고수량인 창고 양식을 올려주세요: ' + bad.join(', ');
          return;
        }
        const names = list.map(x => x.name);
        const kept = ((this.lists[key] && this.lists[key].parts) || []).filter(pt => !names.includes(pt.name));
        // parts = 파일별 원본(화주별 출고리스트에 원본 헤더를 쓴다). aoa 는 크다(수천 행) — 얼려서 Vue 가 들여다보지 않게 한다
        const parts = kept.concat(list.map(x => Object.freeze({ name: x.name, aoa: Object.freeze(x.aoa) })));
        this.setListParts(key, parts);
        // 출고리스트 파일명에 날짜가 있으면 그날 方数计划 으로(없으면 고른 날짜 그대로)
        const d = dateFromName(files[0].name);
        if (d && d !== this.planDate) this.planDate = d;
        // 저장 → 자동 출고(待出库 탭 업로드와 같은 길, 2026-10-07 YZY 「合并到一起」). 실패해도 이 화면의 서류 생성은 올린 파일로 그대로 된다.
        // 기다리지 않는다 — 저장은 옆에서 돌고(saveMsg 한 줄), 자동 출고는 서버 백그라운드라 화면은 바로 쓴다(2026-10-07 YZY 「页面取消掉 后台进行」)
        if (this.saveOutbound) this.saveToServer(files, key, d || this.planDate);
      } catch (err) {
        console.error('출고리스트 읽기 실패:', err);
        this.error = '读取失败(읽기 실패): ' + err.message;
      } finally {
        this.busy = false;
      }
    },
    async saveToServer(files, key, date) {
      const hint = Object.assign({}, this.slotHint);
      files.forEach(f => { hint[f.name.trim()] = key; });
      this.slotHint = hint;
      this.saveBusy = true;
      this.saveMsg = '保存中(서버 저장 중) — ' + date + '…';
      try {
        const msg = await this.saveOutbound(files, date);
        this.saveMsg = '✓ ' + date + ' ' + msg + ' — 有问题的行在「出库列表 → 待出库列表」里的「待手动匹配」处理(남은 행은 出库列表 → 待出库列表 탭 맨 위 「待手动匹配」 구역에서)';
        if (date === this.planDate) await this.loadSaved();
      } catch (err) {
        console.error('출고리스트 저장·자동 출고 실패:', err);
        this.saveMsg = '';
        this.error = '保存到服务器失败(서버 저장·자동 출고 실패 — 서류 생성은 그대로 됩니다): ' + err.message;
      } finally {
        this.saveBusy = false;
      }
    },
    // 파일 묶음 → 한 표(열은 mergeAoa 가 헤더 이름으로 맞춘다). 핵심 칸이 아예 다른 양식인 파일만 빼고(skipped, 목록에 빨갛게) 나머지로 만든다
    setListParts(key, parts) {
      const skipped = [];
      const ok = parts.filter(pt => {
        const problems = listHeaderProblems(pt.aoa && pt.aoa[0]);
        if (problems.length) skipped.push({ name: pt.name, problems });
        return !problems.length;
      });
      if (skipped.length) console.error('출고리스트 양식이 다른 파일 제외:', skipped);
      if (!ok.length) {
        // 전부 다른 양식 — 칸은 비우고 어느 파일·어느 열인지 알린다
        if (skipped.length) this.error = '不是出库清单格式，未读取(출고리스트 양식이 아니라 읽지 않았습니다): ' + skipped.map(s => '「' + s.name + '」 ' + this.skippedText(s)).join(' / ');
        this.lists[key] = null;
        if (this.mode === key) this.useList(this.lists.integrated ? 'integrated' : 'separate');
        return;
      }
      const aoa = ok.length === 1 ? ok[0].aoa : Object.freeze(mergeAoa(ok));
      const parsed = withBarcodeRows(parseWarehouseList(aoa)); // 바코드 없는 행도 인보이스에는 넣는다(파서 rows 자체는 그대로)
      if (key === 'integrated') setOwnerAll(parsed, this.integratedTo); // 综合清关 = 전체가 수취인 명의
      else { this.refreshAutoMerge(parsed); this.applyMergeTo(parsed); } // 单独清关 화주 합치기(같은 营业执照 자동 + 직원이 고른 것)
      this.lists[key] = Object.freeze({ names: parts.map(pt => pt.name), aoa, parsed, parts, skipped, missing: ok.length > 1 ? listMissingCols(ok) : [], palletCount: listPallets(parsed).length });
      this.useList(key);
      this.refreshFixed();
    },
    // 제외된 파일 안내 한 줄(중국어 + 한국어)
    skippedText(s) {
      return s.problems.map(p => p.col + '列应是「' + p.want + '」，现在是「' + (p.got || '空') + '」').join('；') +
        '(' + s.problems.map(p => p.col + '열이 「' + p.want + '」 이어야 하는데 「' + (p.got || '빈칸') + '」').join(', ') + ')';
    },
    // 올린 파일 하나 빼기(name = null 이면 전부)
    // 서버에 저장된 파일(같은 이름의 저장본)이면 ✕ 도 서버 삭제(deleteSaved: 확인창·출고 취소)까지 한다 — 화면 목록만 빼면 새로고침 때 저장본이 다시 들어온다(2026-10-08 YZY)
    async removeFile(key, name) {
      const l = this.lists[key];
      if (!l) return;
      this.error = '';
      this.batchMsg = '';
      const names = name === null ? l.names.slice() : [name];
      const gone = [];
      for (const n of names) {
        const f = this.deleteOutbound && this.savedFiles.find(sf => sf.fileName.trim() === String(n).trim());
        if (f) {
          if (this.savedDeleting) return;
          await this.deleteSaved(f);
          if (this.savedFiles.some(sf => sf.fileName === f.fileName)) return; // 취소했거나 일부 출고 유지로 파일이 남았다 — 화면에서도 그대로 둔다
        }
        gone.push(n);
      }
      try {
        const cur = this.lists[key];
        this.setListParts(key, cur ? cur.parts.filter(pt => !gone.includes(pt.name)) : []);
      } catch (err) {
        console.error('출고리스트 빼기 실패:', err);
        this.error = '读取失败(읽기 실패): ' + err.message;
      }
    },
    // 고른 날짜의 출고리스트 저장본(표 포함)을 읽어 칸에 넣는다. 없으면 지금처럼 파일을 올린다
    async loadSaved() {
      const date = this.planDate;
      this.savedFiles = [];
      this.savedSlot = {};
      if (!date) return;
      this.savedBusy = true;
      try {
        const { data } = await axios.post('/api/coupassOutboundList/get', { date, aoa: true });
        if (date !== this.planDate) return; // 그새 날짜를 바꿨다
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '불러오기 실패');
        // 표가 크다(수천 행) — 얼려서 Vue 가 들여다보지 않게 한다
        const files = (data.files || []).filter(f => Array.isArray(f.aoa) && f.aoa.length > 1)
          .map(f => Object.freeze({ fileName: f.fileName, date: f.date || date, summary: f.summary || null, autoJob: f.autoJob || null, keptReason: f.keptReason || null, aoa: Object.freeze(f.aoa), rows: Object.freeze(f.rows || []) }));
        const slot = {};
        files.forEach(f => { slot[f.fileName] = this.guessSlot(f); });
        this.savedSlot = slot;
        this.savedFiles = files;
        this.applySaved(); // 저장본이 없는 날이면 이전 날짜 저장본만 빠지고 직접 올린 파일은 그대로
      } catch (err) {
        console.error('출고리스트 저장본 불러오기 실패:', err);
        this.error = '读取保存的出库清单失败(저장된 출고리스트 읽기 실패): ' + err.message;
      } finally {
        if (date === this.planDate) this.savedBusy = false;
      }
    },
    // 파일의 통관유형 행 수(대표행, 파렛트라벨 → 구매요청 순으로 서버가 정한 값)
    savedTypes(f) {
      const out = {};
      (f.rows || []).forEach(r => { if (r.대표여부 && r.customsType) out[r.customsType] = (out[r.customsType] || 0) + 1; });
      return out;
    },
    // 칸 기본값 — 데이터가 많은 쪽, 데이터가 없으면 파일명(「단독통관」), 그것도 없으면 综合
    guessSlot(f) {
      if (this.slotHint[f.fileName]) return this.slotHint[f.fileName];
      return outboundListSlot(f); // 箱单发票列表 화주별 출고리스트와 같은 규칙(invoiceRecord.js)
    },
    // 고른 칸과 데이터 통관유형이 다른 托盘号 — 빨간 표시만(생성은 막지 않는다)
    savedConflict(f) {
      const slot = this.savedSlot[f.fileName];
      if (!slot) return [];
      const ids = new Set();
      (f.rows || []).forEach(r => { if (r.customsType && CUSTOMS_SLOT[r.customsType] && CUSTOMS_SLOT[r.customsType] !== slot) ids.add(r.파렛트번호 || '-'); });
      return [...ids];
    },
    toggleSavedOpen() {
      this.savedOpen = !this.savedOpen;
      lsSet(LS_SAVED_OPEN, this.savedOpen);
    },
    customsLabel(t) { return CUSTOMS_LABEL[t] || t; },
    savedJobRunning(f) { return !!(f && f.autoJob && f.autoJob.status === 'running'); },
    // 저장본 파일 삭제 — 확인창·출고 취소·결과 알림은 待出库 와 같은 메서드(deleteOutbound). 끝나면 저장본을 다시 읽는다(지워졌으면 칸에서도 빠진다)
    async deleteSaved(f) {
      if (!this.deleteOutbound || this.savedDeleting) return;
      this.savedDeleting = f.fileName;
      try {
        const done = await this.deleteOutbound(f);
        if (done) await this.loadSaved();
      } catch (err) {
        console.error('출고리스트 저장본 삭제 실패:', err);
        this.error = '删除失败(삭제 실패): ' + err.message;
      } finally {
        this.savedDeleting = '';
      }
    },
    setSavedSlot(name, v) {
      this.savedSlot = Object.assign({}, this.savedSlot, { [name]: v });
      this.applySaved();
    },
    // 저장본을 칸별로 묶어 업로드와 같은 길(setListParts)로 넣는다 — 그 뒤 표·일괄 생성·한 건 생성은 파일을 올렸을 때와 똑같다
    applySaved() {
      this.error = '';
      this.batchMsg = '';
      ['separate', 'integrated'].forEach(key => {
        const names = this.savedFiles.map(f => f.fileName);
        // 직접 올린 파일(saved 표시 없음)은 남긴다 — 저장본 이름과 같으면 저장본으로 바꾼다. 다른 날짜 저장본은 뺀다
        const kept = ((this.lists[key] && this.lists[key].parts) || []).filter(pt => !pt.saved && !names.includes(pt.name));
        const parts = this.savedFiles.filter(f => this.savedSlot[f.fileName] === key)
          .map(f => Object.freeze({ name: f.fileName, aoa: f.aoa, saved: true })).concat(kept);
        if (!parts.length && !this.lists[key]) return;
        try {
          this.setListParts(key, parts);
        } catch (err) {
          console.error('출고리스트 저장본 적용 실패:', err);
          this.error = '读取失败(읽기 실패): ' + err.message;
        }
      });
    },
    // 箱单发票 기록 박스에 선적 id — 저장본 행이 출고 반영 때 받은 shipmentIds(같은 업체·바코드·박스번호)
    withShipmentIds(boxes) {
      const map = new Map();
      this.savedFiles.forEach(f => f.rows.forEach(r => {
        if (!r.shipmentIds || !r.shipmentIds.length) return;
        const k = [r.companyid, r.바코드, r.박스번호].join('|');
        map.set(k, (map.get(k) || []).concat(r.shipmentIds.map(String)));
      }));
      if (!map.size) return boxes;
      return boxes.map(b => {
        const ids = map.get([b.companyid, b.바코드, b.박스번호].join('|'));
        return ids ? Object.assign({}, b, { shipmentIds: [...new Set(ids)] }) : b;
      });
    },
    // 托盘号 표·한 건 생성이 볼 출고리스트(综合/单独)를 바꾼다
    useList(key) {
      const l = this.lists[key];
      this.mode = key;
      this.selected = [];
      this.model = null;
      this.companyFilter = '';
      this.palletFilter = [];
      this.pallets = [];
      if (!l) return;
      this.aoa = l.aoa;
      this.parsed = l.parsed;
      this.fileName = l.names.join(', ');
      this.pallets = this.sortedPallets(l.parsed);
      if (!this.pallets.length) this.error = '没有托盘号(파렛트번호가 적힌 행이 없습니다)';
    },
    // 托盘号 — 글자 없는 번호 먼저, 글자 있는 번호(P01·KD01) 뒤(2026-10-06 YZY)
    sortedPallets(parsed) { return listPallets(parsed).sort((a, b) => comparePalletId(a.id, b.id)); },
    // 方数计划 이 바뀌면 지금 고른 托盘 전부에 다시 채운다(尺寸·体积 — 고칠 수 있다)
    // 자동값을 새 계획표로 다시 잡고 수정값은 그대로 덮는다
    applyPlanToModel() {
      if (!this.model || !this.plan) return;
      this.model.pallets.forEach(p => {
        restoreAutoVolume(p);
        this.$set(p, 'planHit', applyVolumePlan(p, this.plan));
        markAutoVolume(p);
        applyVolumeEdit(p, this.volEditOf(this.mode, p.id));
      });
    },
    setPlan(doc) {
      this.plan = doc ? rowsToPlan(doc.rows) : null;
      this.planName = doc ? (doc.fileName || '-') : '';
      this.planBy = doc ? [doc.uploadedBy, doc.uploadedAt ? new Date(doc.uploadedAt).toLocaleString() : ''].filter(Boolean).join(' ') : '';
      this.applyPlanToModel();
    },
    // 고른 날짜의 方数计划 을 서버에서 불러온다
    async loadPlan() {
      const date = this.planDate;
      if (!date) { this.setPlan(null); return; }
      this.planBusy = true;
      try {
        const { data } = await axios.post('/api/coupassVolumePlan/get', { date });
        if (date !== this.planDate) return; // 그새 날짜를 바꿨다
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '불러오기 실패');
        this.setPlan(data.plan);
      } catch (err) {
        console.error('方数计划 불러오기 실패:', err);
        this.setPlan(null);
        alert('方数计划读取失败(방수계획 불러오기 실패): ' + err.message);
      } finally {
        if (date === this.planDate) this.planBusy = false;
      }
    },
    // 方数计划 올리기 — 고른 날짜로 서버에 저장(같은 날 것이 있으면 확인 후 교체)
    async onPlanFile(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      const date = this.planDate;
      if (!date) { alert('请先选择日期(날짜를 먼저 고르세요)'); return; }
      try {
        // 굵은 테두리 = 综合清关 세트 경계(2026-10-06 YZY). 못 읽어도 尺寸·方数 는 그대로 쓴다(일괄 생성만 막힌다)
        let breaks = null;
        try {
          breaks = readPlanBreaks(new Uint8Array(await file.arrayBuffer()));
        } catch (err) {
          console.error('方数计划 테두리 읽기 실패:', err);
        }
        const plan = parseVolumePlan(await this.readAoa(file), breaks);
        if (!plan.size) throw new Error('没有托盘号(托盘号 칸이 비어 있습니다)');
        const msgs = [];
        const fd = dateFromName(file.name);
        if (fd && fd !== date) msgs.push('文件名日期是 ' + fd + '，将保存为 ' + date + ' 的方数计划(파일명 날짜 ' + fd + ' — ' + date + ' 로 저장됩니다)');
        if (this.planName) msgs.push(date + ' 已有方数计划(' + this.planName + ')，要覆盖吗?(이미 있는 방수계획을 바꿀까요?)');
        if (msgs.length && !confirm(msgs.join('\n\n'))) return;
        this.planBusy = true;
        const { data } = await axios.post('/api/coupassVolumePlan/save', { date, fileName: file.name, rows: planToRows(plan) });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '저장 실패');
        if (date === this.planDate) this.setPlan(data.plan);
      } catch (err) {
        console.error('方数计划 저장 실패:', err);
        alert('方数计划保存失败(방수계획 저장 실패): ' + err.message);
      } finally {
        this.planBusy = false;
      }
    },
    // 올린 출고리스트의 (화주, 바코드) 로 고정 申报金额를 서버에서 읽는다 — 읽기 실패를 조용히 넘기면 申报单价가 틀린 채 만들어지므로 ensureFixed 가 막는다
    async refreshFixed(rebuildAfter = true) {
      const items = new Map();
      ['integrated', 'separate'].forEach(k => {
        const l = this.lists[k];
        if (l && l.parsed) l.parsed.rows.forEach(r => { if (r.바코드) items.set(r.companyid + '|' + r.바코드, { companyid: r.companyid, barcode: r.바코드 }); });
      });
      if (!items.size) { this.fixedMap = {}; this.namesMap = {}; this.fixedErr = ''; return true; }
      try {
        const { data } = await axios.post('/api/coupassLabel/fixedPrices', { items: [...items.values()] });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '조회 실패');
        const changed = JSON.stringify(data.map || {}) !== JSON.stringify(this.fixedMap) || JSON.stringify(data.names || {}) !== JSON.stringify(this.namesMap);
        this.fixedMap = data.map || {};
        this.namesMap = data.names || {};
        this.fixedErr = '';
        if (changed && rebuildAfter && this.model) this.rebuild();
        return true;
      } catch (err) {
        console.error('고정 申报金额 읽기 실패:', err);
        this.fixedErr = '固定申报金额读取失败(고정 申报金额를 읽지 못했습니다): ' + err.message;
        return false;
      }
    },
    // 서류를 만들기 직전에 다시 읽는다(韩文标签资料 에서 방금 고쳤을 수 있다). 못 읽으면 만들지 않는다
    async ensureFixed() {
      if (!(await this.refreshFixed(true))) throw new Error(this.fixedErr);
    },
    rebuild() {
      if (!this.selected.length) { this.model = null; return; }
      const prev = this.model && this.model.companyids.join(',');
      // 고쳐 둔 尺寸 은 선택을 바꿔도 유지한다. 毛重·体积 수정값은 volEdits 에 있어 자동값 위에 다시 덮는다(2026-10-07)
      const dims = {};
      ((this.model && this.model.pallets) || []).forEach(p => {
        dims[p.id] = { dims: p.dims, boxes: (p.boxes || []).map(b => ({ code: b.code, dims: b.dims })) };
      });
      const model = buildInvoiceModel(this.aoa, this.parsed, this.selected, { pack: !this.packOff[this.mode], fixed: this.fixedMap, names: this.namesMap });
      model.warnings.push(...barcodeRowsWarnings(this.parsed, model, this.selected));
      model.pallets.forEach(p => {
        if (this.plan) p.planHit = applyVolumePlan(p, this.plan);
        const e = dims[p.id];
        if (e) {
          p.dims = e.dims;
          (p.boxes || []).forEach(b => { const eb = e.boxes.find(x => x.code === b.code); if (eb) b.dims = eb.dims; });
        }
        markAutoVolume(p);
        applyVolumeEdit(p, this.volEditOf(this.mode, p.id));
      });
      this.model = model;
      const co = this.currentCompany();
      if (co && co !== prev) {
        this.importer = Object.assign({ name: '', addr1: '', addr2: '', email: '', tel: '' }, lsGet(LS_IMPORTER + co) || {});
        // 화주가 정해지면 그 화주의 营业执照 첫 장을 자동으로 고른다(등록돼 있으면). 여러 장이면 위에서 바꾼다
        this.licenseId = this.licenseOptions.length ? this.licenseOptions[0]._id : '';
        this.loadLicense();
      }
    },
    currentCompany() { return this.model && this.model.companyids.length === 1 ? this.model.companyids[0] : ''; },
    ownerText(c) { const rc = INTEGRATED_RECIPIENTS.find(x => x.id === c); return rc ? rc.label : c; },
    // 고를 수 있는 营业执照 — 화주가 정해졌으면 그 화주 것만(한 화주에 여러 장), 아니면 전부
    licenseOptionsFor(co) {
      // 综合清关(COUPASS 명의)은 COUPASS · rubycoco 营业执照 중에서 고른다 — COUPASS 가 먼저(기본값, 2026-10-04 YZY)
      if (co === INTEGRATED_OWNER) {
        const rank = c => ['coupass', 'rubycoco'].indexOf(String(c || '').toLowerCase());
        return this.licenseList.filter(l => rank(l.companyid) >= 0).sort((a, b) => rank(a.companyid) - rank(b.companyid));
      }
      return co ? this.licenseList.filter(l => sameCo(l.companyid, co)) : this.licenseList;
    },
    // 单独清关 화주의 营业执照 — options = 그 화주 것(자동 매칭 대상), groups = 수동 변경 드롭다운(그 화주 · COUPASS 등 고정 수취인 · 다른 화주).
    // 고른 장(ownerLicense)이 있으면 그것, 없으면 그 화주 첫 장. COUPASS 등 고정 수취인 장이면 「COUPASS单独清关」(2026-10-06 YZY)
    ownerLicenseOf(co) {
      const options = this.licenseOptionsFor(co);
      const fixed = this.fixedLicenses.filter(l => !options.includes(l));
      const others = this.licenseList.filter(l => !options.includes(l) && !fixed.includes(l));
      const groups = [
        { key: 'own', label: co + '(本货主 이 화주)', list: options },
        { key: 'fixed', label: 'COUPASS(固定收货人 고정 수취인)', list: fixed },
        { key: 'other', label: '其他货主(다른 화주)', list: others }
      ].filter(g => g.list.length);
      const picked = this.licenseList.find(l => l._id === this.ownerLicense[co]) || null;
      // 고른 장이 없고 표에 「COUPASS单独清关」 이 적힌 화주면 COUPASS 营业执照(2026-10-07 YZY). 화주단독 건은 그대로 그 화주 첫 장
      const auto = !picked && this.coupassSepOwners.has(co) ? this.coupassLicense : null;
      const license = picked || auto || options[0] || null;
      const isFixed = !!license && !sameCo(license.companyid, co) && this.fixedLicenses.includes(license);
      return { options, groups, picked, license, byKeyword: !!auto, fixed: isFixed, clearanceLabel: isFixed ? this.ownerText(String(license.companyid).toLowerCase()) + '单独清关' : '单独清关' };
    },
    // 서류 목록 「货主」 구분 — integrated / separate / separate_coupass(单独 인데 COUPASS 등 고정 수취인 营业执照)
    clearanceOf(key, co, licenseId) {
      if (key === 'integrated') return { clearance: 'integrated', clearanceLabel: '综合清关' };
      const lic = this.licenseList.find(l => l._id === licenseId);
      const fixed = !!lic && !sameCo(lic.companyid, co) && this.fixedLicenses.includes(lic);
      return fixed ? { clearance: 'separate_coupass', clearanceLabel: this.ownerText(String(lic.companyid).toLowerCase()) + '单独清关' } : { clearance: 'separate', clearanceLabel: '单独清关' };
    },
    // 收件人信息 입력 창 열기 — doc = 营业执照 목록 한 장
    openRecipient(doc, co) {
      if (!doc) return;
      this.rcpt = { show: true, id: doc._id, co, licenseText: licenseText(doc), recipient: doc.recipient || doc.labelEn || '', addrEn: doc.addrEn || '', email: doc.email || '', tel: doc.tel || '', saving: false };
    },
    async saveRecipient() {
      const r = this.rcpt;
      r.saving = true;
      try {
        const body = { id: r.id, recipient: r.recipient.trim(), addrEn: r.addrEn.trim(), email: r.email.trim(), tel: r.tel.trim() };
        // 营业执照管理 과 같은 규칙 — 영문상호명이 비어 있으면 收件人 으로 채운다
        const doc = this.licenseList.find(l => l._id === r.id);
        if (doc && !String(doc.labelEn || '').trim()) body.labelEn = body.recipient;
        const { data } = await axios.post('/api/coupassInvoiceImage/label', body);
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        r.show = false;
        await this.loadImageList();
      } catch (e) {
        console.error('收件人信息 저장 실패:', e);
        alert('保存失败(저장 실패): ' + e.message);
      } finally {
        r.saving = false;
      }
    },
    markOf(p) { return palletMark(p); },
    // 收货人 Messrs = 고른 营业执照 의 수취정보 — consigneeFrom 참고
    applyLicenseConsignee(doc) {
      if (!doc) return;
      this.importer = consigneeFrom(doc, this.importer);
    },
    // ───── 부피·중량 수동 수정(2026-10-07 YZY) — 서류(箱单发票·서류 기록·BL 대조 기준)에만 쓴다, 원본 출고리스트는 그대로 ─────
    volKey(key, id) { return key + '|' + id; },
    volEditOf(key, id) { return this.volEdits[this.volKey(key, id)] || null; },
    // 세트 합계 — 托盘 자동값 + 수정값. rows = 托盘 별(④ 펼침 표)
    setVolume(key, s) {
      const map = this.autoPallets[key];
      const pre = key === 'separate' ? s.co + '|' : '';
      const ps = map ? s.ids.map(id => map.get(pre + id)).filter(Boolean) : [];
      const rows = ps.map(p => Object.assign({ p }, volumeWithEdit(p, this.volEditOf(key, p.id))));
      const sum = f => Math.round(rows.reduce((t, r) => t + (Number(f(r)) || 0), 0) * 100) / 100;
      return {
        rows,
        gw: sum(r => r.gw), cbm: sum(r => r.cbm),
        autoGw: sum(r => r.p.auto.gw), autoCbm: sum(r => r.p.auto.cbm),
        editGw: rows.some(r => r.edit.gw), editCbm: rows.some(r => r.edit.cbm)
      };
    },
    // 빈 수정은 지운다
    putVolEdit(k, e) {
      const next = {};
      if (e.gw !== undefined) next.gw = e.gw;
      if (e.cbm !== undefined) next.cbm = e.cbm;
      if (e.boxes && Object.keys(e.boxes).length) next.boxes = e.boxes;
      if (Object.keys(next).length) this.$set(this.volEdits, k, next);
      else this.$delete(this.volEdits, k);
    },
    // 한 칸 고치기 — p = 자동값을 가진 托盘(markAutoVolume 뒤). boxCode = 散货 박스 한 칸, null 이면 托盘
    // (散货 托盘 毛重 은 박스 자동값 비율로 나눠 박스에 넣는다 — 箱单发票 이 박스 줄마다 毛重 을 쓴다). raw '' = 자동값으로
    editVol(key, p, boxCode, field, raw) {
      const v = raw === '' || raw === null || raw === undefined ? null : Number(raw);
      if (v !== null && !(isFinite(v) && v >= 0)) return;
      const k = this.volKey(key, p.id);
      const e = Object.assign({}, this.volEdits[k] || {});
      e.boxes = Object.assign({}, e.boxes || {});
      if (boxCode !== null) {
        if (v === null) delete e.boxes[boxCode];
        else e.boxes[boxCode] = v;
      } else if (field === 'gw' && hasBoxRows(p)) {
        e.boxes = {};
        if (v !== null) {
          const parts = splitTotal(v, p.boxes.map(b => b.autoGw));
          p.boxes.forEach((b, i) => { e.boxes[b.code] = parts[i]; });
        }
      } else if (v === null) delete e[field];
      else e[field] = v;
      this.putVolEdit(k, e);
    },
    // 세트 합계 고치기 — 托盘 자동값 비율로 나눈다(합 = 넣은 값 정확히). 빈칸 = 이 칸 자동값으로
    editSetVol(key, s, field, raw) {
      const rows = (s.vol && s.vol.rows) || [];
      if (!rows.length) return;
      const v = raw === '' || raw === null ? null : Number(raw);
      if (v !== null && !(isFinite(v) && v >= 0)) return;
      // 毛重 은 托盘 마다 십 단위 내림 + 차액 10 씩 앞 托盘부터, 나머지는 첫 托盘(splitPalletKg, 2026-10-07 YZY). 体积 은 소수 둘째 자리 비율
      const bases = rows.map(r => r.p.auto[field]);
      const parts = v === null ? null : field === 'gw' ? splitPalletKg(v, bases) : splitTotal(v, bases);
      rows.forEach((r, i) => this.editVol(key, r.p, null, field, parts ? parts[i] : ''));
    },
    revertSetVol(key, s) {
      ((s.vol && s.vol.rows) || []).forEach(r => this.$delete(this.volEdits, this.volKey(key, r.p.id)));
    },
    toggleVolOpen(k) { this.$set(this.volOpen, k, !this.volOpen[k]); },
    gwEdited(bl) { return bl.box ? !!bl.t.edited : !!(bl.p.volEdit && bl.p.volEdit.gw); },
    applyVolEditsToModel() {
      if (this.model) this.model.pallets.forEach(p => applyVolumeEdit(p, this.volEditOf(this.mode, p.id)));
    },
    // 그 날짜 서류 기록에 남은 수정값(pallets[].volEdit)을 다시 읽는다 — 같은 托盘 은 최근 서류 값. 화면에서 이미 고친 값이 먼저
    async loadVolEdits() {
      const date = this.planDate;
      this.volEdits = {};
      if (!date) return;
      try {
        const { data } = await axios.post('/api/coupassInvoiceRecord/list', { planDate: date });
        if (date !== this.planDate) return;
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '불러오기 실패');
        const next = {};
        (data.list || []).filter(r => r.planDate === date).forEach(r => { // 목록은 최근 저장 순
          const key = r.clearance === 'integrated' ? 'integrated' : 'separate';
          (r.pallets || []).forEach(p => {
            const k = this.volKey(key, p.id);
            if (next[k] || !p || !p.volEdit) return;
            const e = {};
            if (p.volEdit.cbm) e.cbm = Number(p.cbm) || 0;
            if (p.volEdit.gw) {
              const bx = (p.boxes || []).filter(b => b.edited);
              if (bx.length) { e.boxes = {}; bx.forEach(b => { e.boxes[b.code] = Number(b.gw) || 0; }); } else e.gw = Number(p.gw) || 0;
            }
            if (Object.keys(e).length) next[k] = e;
          });
        });
        this.volEdits = Object.assign(next, this.volEdits);
      } catch (err) {
        console.error('箱单发票 부피·중량 수정값 불러오기 실패:', err);
      }
    },
    licenseText(l) { return licenseText(l); },
    // 지금 보이는(필터된) 托盘号 를 한꺼번에 고르거나 푼다
    selectFiltered(on) {
      const ids = this.filteredPallets.map(p => p.id);
      this.selected = on ? [...new Set(this.selected.concat(ids))] : this.selected.filter(id => !ids.includes(id));
    },
    imgFromDoc(doc) {
      if (!doc || !doc.data) return null;
      return { name: doc.name || '', type: doc.type, data: b64ToU8(doc.data), width: doc.width, height: doc.height };
    },
    async loadImageList() {
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/list', {});
        if (data.요청결과 !== '성공') { console.error('箱单发票 이미지 목록 실패:', data.error); return; }
        this.imageList = data.list || [];
        if (!this.shipperOptions.some(x => x._id === this.shipperId)) this.shipperId = SHIPPER_DEFAULT;
        if (this.sealId && !this.sealOptions.some(x => x._id === this.sealId)) {
          this.sealId = this.sealOptions.length ? this.sealOptions[0]._id : '';
          this.loadSeal();
        }
        // 고른 장이 지워졌으면 비우고, 파일보다 목록이 늦게 오면 화주 자동선택을 여기서 다시
        if (this.licenseId && !this.licenseOptions.some(l => l._id === this.licenseId)) { this.licenseId = ''; this.images.license = null; }
        if (this.currentCompany() && !this.licenseId && this.licenseOptions.length) {
          this.licenseId = this.licenseOptions[0]._id;
          this.loadLicense();
        }
        if (this.lists.separate) this.applyOwnerMerge(); // 营业执照 목록이 파일보다 늦게 왔으면 자동 합치기를 여기서
      } catch (e) {
        console.error('箱单发票 이미지 목록 실패:', e);
      }
    },
    async loadSeal() {
      const id = this.sealId;
      this.savePick();
      this.images.seal = null;
      if (!id) return;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/get', { id });
        if (data.요청결과 !== '성공') { console.error('印章 읽기 실패:', data.error); return; }
        if (this.sealId === id) this.images.seal = this.imgFromDoc(data.image);
      } catch (e) {
        console.error('印章 읽기 실패:', e);
      }
    },
    async loadLicense() {
      const id = this.licenseId;
      this.images.license = null;
      if (!id) return;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/get', { id });
        if (data.요청결과 !== '성공') { console.error('营业执照 읽기 실패:', data.error); return; }
        if (this.licenseId !== id) return;
        this.images.license = this.imgFromDoc(data.image);
        this.applyLicenseConsignee(data.image);
      } catch (e) {
        console.error('营业执照 읽기 실패:', e);
      }
    },
    async saveImage(kind, companyid, file, add) {
      this.imgBusy = true;
      try {
        const img = await shrinkImage(file, kind);
        // 印章 은 여러 장 — 올리면 한 장 더(add). 처음 한 장은 'seal'. 营业执照 도 add 면 그 화주에 한 장 더(이미 있는 장을 덮지 않는다)
        const { data } = await axios.post('/api/coupassInvoiceImage/save', Object.assign({ kind, companyid, add: add === undefined ? kind === 'seal' : !!add }, img));
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        await this.loadImageList();
        return Object.assign({ _id: data.image && data.image._id }, img);
      } catch (e) {
        console.error('箱单发票 이미지 저장 실패:', e);
        alert('保存失败(저장 실패): ' + e.message);
        return null;
      } finally {
        this.imgBusy = false;
      }
    },
    async onSealFile(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      const img = await this.saveImage('seal', '', file);
      if (img && img._id) { this.sealId = img._id; this.loadSeal(); }
    },
    async deleteSeal() {
      const sl = this.sealOptions.find(x => x._id === this.sealId);
      if (!sl || !confirm('删除印章?(도장을 삭제할까요?) ' + (sl.label || sl.name))) return;
      this.imgBusy = true;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/delete', { id: sl._id });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '删除失败');
        this.sealId = '';
        await this.loadImageList();
        this.sealId = this.sealOptions.length ? this.sealOptions[0]._id : '';
        this.loadSeal();
      } catch (e) {
        console.error('印章 삭제 실패:', e);
        alert('删除失败(삭제 실패): ' + e.message);
      } finally {
        this.imgBusy = false;
      }
    },
    // 单独清关 화주에 营业执照 가 없을 때 그 자리에서 올린다 — 올리면 바로 收件人信息 입력 창(2026-10-06 YZY)
    async onOwnerLicenseFile(e, co) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file || !co) return;
      const img = await this.saveImage('license', co, file, true);
      if (!img || !img._id) return;
      this.pickOwnerLicense(co, img._id);
      this.openRecipient(this.licenseList.find(l => l._id === img._id) || { _id: img._id, companyid: co, name: img.name }, co);
    },
    // 方数计划 삭제 — 고른 날짜의 계획표(2026-10-06 YZY)
    async deletePlan() {
      const date = this.planDate;
      if (!date || !this.planName) return;
      if (!confirm('删除 ' + date + ' 的方数计划(' + this.planName + ')?\n(' + date + ' 방수계획을 삭제할까요?)')) return;
      this.planBusy = true;
      try {
        const { data } = await axios.post('/api/coupassVolumePlan/delete', { date });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '删除失败');
        if (date === this.planDate) this.setPlan(null);
      } catch (err) {
        console.error('方数计划 삭제 실패:', err);
        alert('删除失败(삭제 실패): ' + err.message);
      } finally {
        this.planBusy = false;
      }
    },
    pickOwnerLicense(co, id) { this.$set(this.ownerLicense, co, id); if (this.lists.separate) this.applyOwnerMerge(); }, // 营业执照 를 고르면 같은 장으로 매칭되는 화주를 자동으로 합친다
    // ③ 营业执照 검색 선택
    licPickedText(m) { for (const g of m.groups || []) { const l = g.list.find(x => x._id === m.licenseId); if (l) return licenseText(l); } return ''; },
    openLic(co) { this.licOpen = co; this.licQuery = ''; },
    closeLic(co) { if (this.licOpen === co) this.licOpen = ''; },
    licFiltered(m) {
      const q = this.licQuery.replace(/\s+/g, '').toLowerCase();
      return (m.groups || []).map(g => Object.assign({}, g, { list: q ? g.list.filter(l => licenseText(l).replace(/\s+/g, '').toLowerCase().includes(q) || g.label.replace(/\s+/g, '').toLowerCase().includes(q)) : g.list })).filter(g => g.list.length);
    },
    chooseLic(co, id) { this.pickOwnerLicense(co, id); this.licOpen = ''; },
    // 单独清关 화주 합치기(2026-10-07 YZY 「한 고객이 계정 여러 개 — 한 계정으로 같이 발송」) — 행의 货主(invoiceOwner)를 대표 화주로.
    // 원래 화주(companyid)는 그대로라 托盘 표·서류 기록 pallets.origCompanyids 에 남는다. 세트·营业执照·产地证 는 대표 화주 하나로
    applyMergeTo(parsed) {
      ((parsed && parsed.rows) || []).forEach(r => { const rep = this.ownerMerge[r.companyid] || this.autoOwnerMerge[r.companyid]; if (rep) r.invoiceOwner = rep; else delete r.invoiceOwner; });
    },
    // 单独清关 에서 같은 营业执照 로 매칭되는 서로 다른 화주를 자동으로 합친다(2026-10-08 YZY, #1205 의 수동 합치기 자동화).
    // 综合清关 은 부르지 않는다. 직원이 손으로 합친 화주는 우선, 해제한 营业执照 는 다시 안 합친다(ownerAutoMerge.js)
    refreshAutoMerge(parsed) {
      if (!parsed) return;
      const owners = [...new Set((parsed.rows || []).map(r => r.companyid))].map(co => {
        const picked = this.licenseList.find(l => l._id === this.ownerLicense[co]);
        const lic = picked || this.licenseOptionsFor(co)[0] || null;
        // COUPASS 등 고정 수취인 营业执照 는 자동 합치기에서 뺀다(여러 화주가 같이 쓰는 장이라 전부 한 세트가 되어 버린다)
        return { co, licenseId: lic && !this.fixedLicenses.includes(lic) ? lic._id : '', licenseCo: lic ? lic.companyid : '' };
      });
      const plan = planAutoMerge(owners, this.ownerMerge, this.autoMergeOff);
      this.autoOwnerMerge = plan.merge;
      this.autoOwnerLic = plan.lic;
      // 합친 세트는 매칭된 그 营业执照 를 쓴다(대표 화주 쪽에 다른 장이 있어도)
      Object.keys(plan.lic).forEach(rep => { if (this.ownerLicense[rep] !== plan.lic[rep]) this.$set(this.ownerLicense, rep, plan.lic[rep]); });
    },
    applyOwnerMerge() {
      const ls = this.lists.separate;
      if (!ls) return;
      this.refreshAutoMerge(ls.parsed);
      this.applyMergeTo(ls.parsed);
      this.lists.separate = Object.freeze(Object.assign({}, ls)); // 새 객체 — 세트·매칭 표가 다시 계산된다
      if (this.mode !== 'separate') return;
      this.pallets = this.sortedPallets(ls.parsed);
      this.rebuild();
    },
    mergeOwners() {
      const pick = this.mergePick.slice();
      if (pick.length < 2) return;
      const rep = pick.includes(this.mergeRep) ? this.mergeRep : pick[0];
      const next = Object.assign({}, this.autoOwnerMerge, this.ownerMerge); // 자동으로 합쳐진 것도 손으로 고른 것에 포함시킨다
      // 이미 합친 세트를 또 고르면 그 세트 화주들도 같이 옮긴다
      pick.forEach(p => {
        Object.keys(next).forEach(m => { if (next[m] === p) next[m] = rep; });
        if (p !== rep) next[p] = rep;
      });
      delete next[rep];
      this.ownerMerge = next;
      this.mergePick = [];
      this.mergeRep = '';
      this.applyOwnerMerge();
    },
    unmergeOwner(rep) {
      if (this.autoOwnerLic[rep]) this.$set(this.autoMergeOff, this.autoOwnerLic[rep], true); // 자동으로 합친 것을 해제 — 그 营业执照 는 다시 자동 합치지 않는다
      const next = Object.assign({}, this.ownerMerge);
      Object.keys(next).forEach(m => { if (next[m] === rep) delete next[m]; });
      this.ownerMerge = next;
      this.applyOwnerMerge();
    },
    cooNeededFor(amount) { return cooNeeded(amount); },
    cooLabel(code) { const t = cooChoice(code); return t ? t.label : code; },
    // 화면 구분용 색(2026-10-08 YZY) — 선택칸·배지에 쓴다
    cooStyle(code) { const t = cooChoice(code); return t ? { color: t.color, backgroundColor: t.bg, fontWeight: 'bold' } : {}; },
    // 고른 값, 없으면 기본값 — 금액을 알면(amount) 230 미만은 无需做产地证(NONE), 모르면 batchViews 에서 그 세트 금액을 찾는다. 이미 고른 값은 그대로(하위호환: 옛 FCN1/E1/FRCCN1)
    setCooOf(key, amount) {
      if (this.setCooType[key]) return this.setCooType[key];
      let a = amount;
      if (a === undefined) { for (const b of this.batchViews) { const st = b.sets.find(x => x.cooKey === key); if (st) { a = st.amount; break; } } }
      return a !== undefined && !cooNeeded(a) ? COO_NONE_CODE : 'FCN1';
    },
    setRecipientOf(key) { return this.setRecipient[key] || this.integratedTo; },
    // 기본값과 같은 걸 고르면 지정을 지운다 — 그 뒤엔 위 默认收货人 을 따라간다
    setSetRecipient(key, id) { if (id === this.integratedTo) this.$delete(this.setRecipient, key); else this.$set(this.setRecipient, key, id); },
    // 综合清关 세트들의 收货人 이름(중복 없이, 첫 등장 순) — 버튼·zip 이름
    integratedWho(sets) { return [...new Set(sets.map(s => s.rcpt || this.integratedTo))].map(this.ownerText).join('+'); },
    setSetCoo(key, code) { this.$set(this.setCooType, key, code); },
    savePick() { lsSet(LS_PICK, { shipperId: this.shipperId, sealId: this.sealId }); },
    // 发货人 고르기 → 발송인 칸 + 그 발송인의 印章
    pickShipper() {
      const sp = this.shipperOptions.find(x => x._id === this.shipperId);
      if (!sp) return;
      this.info.exporter = { name: sp.name || '', addr1: sp.addr1 || '', addr2: sp.addr2 || '' };
      if (sp.sealId && this.sealOptions.some(x => x._id === sp.sealId)) this.sealId = sp.sealId;
      this.loadSeal();
    },
    async saveShipper(asNew) {
      const e = this.info.exporter;
      if (!String(e.name || '').trim()) { alert('请填写发货人名称(발송인 이름을 적어 주세요)'); return; }
      this.imgBusy = true;
      try {
        const body = { name: e.name, addr1: e.addr1, addr2: e.addr2, sealId: this.sealId };
        if (!asNew) body.id = this.shipperId;
        const { data } = await axios.post('/api/coupassInvoiceImage/shipper', body);
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        await this.loadImageList();
        this.shipperId = data.shipper._id;
        this.savePick();
      } catch (err) {
        console.error('发货人 저장 실패:', err);
        alert('保存失败(저장 실패): ' + err.message);
      } finally {
        this.imgBusy = false;
      }
    },
    async deleteShipper() {
      const sp = this.shipperOptions.find(x => x._id === this.shipperId);
      if (!sp || !confirm('删除发货人?(발송인을 삭제할까요?) ' + sp.name)) return;
      this.imgBusy = true;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/delete', { id: sp._id });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '删除失败');
        await this.loadImageList();
        this.shipperId = SHIPPER_DEFAULT; // 기본을 지웠으면 코드의 기본값으로 돌아간다
        this.pickShipper();
      } catch (err) {
        console.error('发货人 삭제 실패:', err);
        alert('删除失败(삭제 실패): ' + err.message);
      } finally {
        this.imgBusy = false;
      }
    },
    saveFile(data, name, type) {
      const blob = new Blob([data], { type });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = name;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    },
    async download() {
      try {
        await this.ensureFixed();
        const info = Object.assign({}, this.info, { importer: this.importer });
        const out = writeInvoiceXlsx(this.model, info, this.images, this.cooDone ? coRefOf(this.cooFiles) : null);
        this.saveFile(out, invoiceFileName(info, this.model), XLSX_MIME);
        this.saveRecord(this.cooDone);
      } catch (e) {
        console.error('인보이스 생성 실패:', e);
        alert('生成失败(생성 실패): ' + e.message);
      }
    },
    // 箱单发票列表 에 남긴다(같은 화주·托盘号 묶음이면 고친다). withCoo = 产地证 도 만들었을 때
    async saveRecord(withCoo) {
      const record = this.recordOf({ model: this.model, importer: this.importer, licenseId: this.licenseId, cooFiles: this.cooFiles, ids: this.selected, aoa: this.aoa, parsed: this.parsed, fileName: this.fileName, withCoo,
        extra: this.clearanceOf(this.mode, this.currentCompany(), this.licenseId) });
      await this.askReplace([record]);
      const err = await this.postRecord(record);
      this.recordErr = !!err;
      this.recordMsg = err ? '保存到列表失败(목록 저장 실패): ' + err : '✓ 已保存到箱单发票列表(서류 목록에 저장)';
    },
    // 箱单发票列表 에 남길 한 건 — 한 건 생성·일괄 생성 공용
    // extra = { seq, docName, clearance, clearanceLabel } — 서류 목록 순서·구분(일괄 생성). planDate = 方数计划 날짜(목록 「日期」 열, 2026-10-06 YZY)
    recordOf({ model: m, importer, licenseId, cooFiles, ids, aoa, parsed, fileName, withCoo, cooNone, extra }) {
      // licenseId — 목록에서 다시 받을 때 같은 营业执照 를 쓰려고 남긴다
      const info = Object.assign({}, this.info, { importer: Object.assign({}, importer), licenseId: licenseId || '', sealId: this.sealId || '' });
      const items = [].concat(...m.pallets.map(p => p.items));
      const sum = f => m.pallets.reduce((s, p) => s + (Number(f(p)) || 0), 0);
      return Object.assign({
        companyids: m.companyids,
        pallets: m.pallets,
        info,
        planDate: this.planDate || '',
        summary: Object.assign({ qty: items.reduce((s, it) => s + it.qty, 0), amount: invoiceAmount(m), packages: packageCountText(m.pallets), gw: sum(p => p.gw), cbm: sum(p => p.cbm) }, cooNone ? { cooNone: true } : {}), // cooNone = 「无需做产地证」를 직접 골랐다(금액 230 이상이어도)
        coo: withCoo ? {
          info: { exporter: this.cooInfo.exporter || this.exporterPlaceholder, vessel: this.cooInfo.vessel || this.info.carrier || '' },
          // no = 몇 번째 产地证(CO1, CO2 …) — 箱单发票 H 열 번호와 같다
          files: cooFiles.map((f, i) => ({ no: i + 1, type: f.type, fileNo: f.no, total: f.total, invoiceNo: cooInvoiceNo(f, m), items: f.items }))
        } : null,
        outHeader: OUT_HEADER,
        outRows: buildOutRows(aoa, parsed, ids, this.fixedMap, this.namesMap),
        boxes: this.withShipmentIds(buildBoxes(parsed, ids)), // 저장본이 출고 반영한 박스면 선적 id 를 싣는다(BL 확인이 그대로 쓴다)
        fileName
      }, extra || {});
    },
    // 覆盖 확인(2026-10-07 YZY) — 같은 날짜·같은 화주에서 托盘 이 겹치는 옛 기록(托盘 묶음이 바뀌어 따로 쌓인 것)이 있으면 묻는다.
    //   覆盖 → record.replaceIds 에 옛 기록 _id(서버가 숨김 표시, 지우지 않음) / 保留两份·닫기 → 지금처럼 둘 다 남긴다
    async askReplace(records) {
      try {
        const { data } = await axios.post('/api/coupassInvoiceRecord/overlaps', {
          records: records.map(r => ({ companyids: r.companyids, palletIds: (r.pallets || []).map(p => p.id), planDate: r.planDate }))
        });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'overlaps 실패');
        const ov = data.overlaps || [];
        const all = [].concat(...ov);
        if (!all.length) return;
        const h = this.$createElement;
        const uniq = [...new Map(all.map(o => [o._id, o])).values()];
        const lines = uniq.slice(0, 8).map(o => h('li', (o.seq ? '#' + o.seq + ' ' : '') + (o.docName || (o.palletIds || []).join(', '))
          + (o.hasBl || o.cooFiles ? ' — ' + [o.hasBl ? '已上传BL' : '', o.cooFiles ? '产地证核对/正本 ' + o.cooFiles : ''].filter(Boolean).join(' · ') : '')));
        if (uniq.length > 8) lines.push(h('li', '… ' + uniq.length + '个'));
        const msg = h('div', [
          h('p', { class: 'mb-1' }, '箱单发票列表里已有同一天、同一货主、托盘重叠的旧记录 ' + uniq.length + '个(같은 날짜·화주·托盘 이 겹치는 옛 기록 ' + uniq.length + '건):'),
          h('ul', { class: 'small mb-2' }, lines),
          h('div', { class: 'small text-muted' }, '覆盖 = 列表只显示新的，旧记录隐藏不删除(上传的BL·产地证文件保留，可在「显示已覆盖」里查看) / 保留两份 = 两份都显示'),
          h('div', { class: 'small text-muted' }, '(덮어쓰기 = 목록엔 새 것만, 옛 기록은 지우지 않고 숨김 — 올린 BL·원산지 파일 보존 / 둘 다 유지 = 지금처럼)')
        ]);
        const ok = await this.$bvModal.msgBoxConfirm(msg, {
          title: '是否覆盖之前生成的箱单发票?(이전에 만든 서류를 덮어쓸까요?)', okVariant: 'warning', okTitle: '覆盖(덮어쓰기)', cancelTitle: '保留两份(둘 다 유지)', centered: true
        }).catch(e => { console.error('覆盖 확인창 오류:', e); return false; });
        if (ok) records.forEach((r, i) => { if ((ov[i] || []).length) r.replaceIds = ov[i].map(o => o._id); });
      } catch (e) {
        // 확인을 못 해도 저장은 한다(지금처럼 둘 다 남는다)
        console.error('覆盖 대상 확인 실패:', e);
      }
    },
    // 저장 — 실패하면 이유 글자, 성공이면 ''
    async postRecord(record) {
      try {
        const { data } = await axios.post('/api/coupassInvoiceRecord/save', { record });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        if (data.blExtracted) await this.recompareBl(record, data);
        return '';
      } catch (e) {
        console.error('箱单发票 기록 저장 실패:', e);
        return e.message || 'error';
      }
    },
    // 이미 BL 을 올린 기록이면 저장해 둔 BL 판독값으로 새 서류와 다시 대조한다(BL 다시 올릴 필요 없음, 2026-10-07 YZY).
    // 실패해도 서류 저장은 된 것 — 목록이 「核对是旧的(옛 대조)」 로 보여 준다
    async recompareBl(record, saved) {
      try {
        const rec = Object.assign({}, record, { coo: record.coo || (saved.cooInfo ? { info: saved.cooInfo } : null) });
        const compare = compareBl(rec, saved.blExtracted);
        const { data } = await axios.post('/api/coupassInvoiceRecord/blCompare', { id: saved._id, compare, basis: saved.savedAt });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || 'blCompare 실패');
      } catch (e) {
        console.error('BL 대조 다시 돌리기 실패:', e);
      }
    },
    // 营业执照 첫 장(화주 기준 licenseOptionsFor 순) — 일괄 생성용. cache = 같은 장 두 번 안 받게
    async licenseFor(co, cache) {
      // 单独清关 수취인 매칭 표에서 고른 장이 있으면 그것, 없으면 첫 장
      const opt = this.ownerLicenseOf(co).license;
      if (!opt) return { id: '', doc: null, image: null };
      if (!cache.has(opt._id)) {
        const { data } = await axios.post('/api/coupassInvoiceImage/get', { id: opt._id });
        if (data.요청결과 !== '성공') throw new Error('营业执照读取失败(사업자등록증 읽기 실패) ' + co + ': ' + ((data.error && data.error.errorMessage) || ''));
        cache.set(opt._id, data.image);
      }
      const doc = cache.get(opt._id);
      return { id: opt._id, doc, image: this.imgFromDoc(doc) };
    },
    // 일괄 생성(2026-10-06 YZY) — 세트마다 箱单发票 1 + 产地证 N, 전부 zip 하나. 세트마다 箱单发票列表 에도 남긴다.
    // 发货人·印章·港口·日期 는 화면에 고른 값 그대로, 产地证 종류는 세트마다 고른 값, 收货人 은 세트 화주의 营业执照(매칭 표에서 고른 장, 없으면 첫 장)에서
    async downloadBatch(key) {
      const view = this.batchViews.find(b => b.key === key);
      const l = this.lists[key];
      if (!view || !l || view.blocker || !view.sets.length) return;
      this.batchBusy = true;
      this.batchErr = false;
      this.batchMsg = '';
      try {
        await this.ensureFixed();
        const out = [];
        const records = [];
        const cache = new Map();
        const d = String(this.planDate || this.info.date || '').replace(/-/g, ''); // zip 이름 = 方数计划 날짜
        const noLicense = [];
        for (let i = 0; i < view.sets.length; i++) {
          const s = view.sets[i];
          const parsed = s.parsed || l.parsed;
          // 综合清关 은 세트 收货人 명의로(货主 = 수취인) — 끝나면 finally 에서 기본값으로 되돌린다
          if (key === 'integrated') setOwnerAll(parsed, s.rcpt || this.integratedTo);
          const model = buildInvoiceModel(l.aoa, parsed, s.ids, { pack: !this.packOff[key], fixed: this.fixedMap, names: this.namesMap });
          model.warnings.push(...barcodeRowsWarnings(parsed, model, s.ids));
          if (this.plan) model.pallets.forEach(p => { p.planHit = applyVolumePlan(p, this.plan); });
          // 부피·중량 수정값(④ 세트·托盘 / ⑤) — 자동값을 잡아 두고 덮는다. 서류 기록 pallets 에 auto·volEdit 가 같이 남는다
          model.pallets.forEach(p => { markAutoVolume(p); applyVolumeEdit(p, this.volEditOf(key, p.id)); });
          const co = model.companyids[0] || '';
          const lic = await this.licenseFor(co, cache);
          if (!lic.id) noLicense.push(this.ownerText(co));
          const importer = consigneeFrom(lic.doc, lsGet(LS_IMPORTER + co));
          const info = Object.assign({}, this.info, { importer });
          // 产地证 종류 = 세트(综合)·화주(单独)마다 고른 하나(기본 韩中FTA, 2026-10-06 YZY)
          // 箱单发票 총금액 230 USD 미만 세트는 产地证 을 만들지 않는다(2026-10-07 YZY) — 箱单发票 H열(CO)도 비고, 목록엔 「无需做产地证」
          const cooType = this.setCooOf(s.cooKey, invoiceAmount(model));
          const withCoo = cooType !== COO_NONE_CODE;
          const cooFiles = withCoo ? splitCooFiles(cooItems(model), () => cooType) : [];
          // zip 안 이름 = 순번 이름(2026-10-06 YZY) 「INVOICE_Coupass-20260930-1(RUBY0930-01~RUBY0930-24)」, 产地证 도 같은 순번. zip 안 순서도 순번 순
          out.push({ name: 'INVOICE_' + s.docBase + '.xlsx', data: writeInvoiceXlsx(model, info, { seal: this.images.seal, license: lic.image }, coRefOf(cooFiles)) });
          cooFiles.forEach(f => out.push({ name: batchCooFileName(f, s.docBase), data: writeCooXlsx(f, model, info, this.cooInfo) }));
          records.push(this.recordOf({ model, importer, licenseId: lic.id, cooFiles, ids: s.ids, aoa: l.aoa, parsed, fileName: l.names.join(', '), withCoo, cooNone: !withCoo,
            extra: Object.assign({ seq: s.seq, docName: s.docBase }, this.clearanceOf(key, co, lic.id)) }));
        }
        const label = key === 'integrated' ? '综合清关_' + this.integratedWho(view.sets) : '单独清关';
        const zipName = ('箱单发票_' + label + '_' + d + '（' + view.sets[0].seq + (view.sets.length > 1 ? '~' + view.sets[view.sets.length - 1].seq : '') + '，' + view.sets.length + '套）').replace(/[\\/:*?"<>|\r\n]+/g, ' ').trim() + '.zip';
        this.saveFile(zipFilesUtf8(out), zipName, 'application/zip');
        let fail = 0;
        await this.askReplace(records);
        for (const rec of records) { if (await this.postRecord(rec)) fail += 1; }
        this.batchErr = fail > 0 || noLicense.length > 0;
        this.batchMsg = '✓ ' + view.sets.length + ' 套 · ' + out.length + ' 个文件 → ' + zipName +
          (fail ? ' · ⚠ 保存到列表失败(목록 저장 실패) ' + fail + '套' : ' · 已保存到箱单发票列表(서류 목록에 저장)') +
          (noLicense.length ? ' · ⚠ 没有营业执照(사업자등록증 없음): ' + noLicense.join(', ') : '');
      } catch (e) {
        console.error('箱单发票 일괄 생성 실패:', e);
        this.batchErr = true;
        this.batchMsg = '生成失败(생성 실패): ' + e.message;
      } finally {
        if (key === 'integrated' && l) setOwnerAll(l.parsed, this.integratedTo); // 세트별 收货人 → ⑤ 한 건 생성·표는 기본 수취인 그대로
        this.batchBusy = false;
      }
    },
    cooTypeOf(hs) { return this.cooTypeByHs[hs] || 'FCN1'; },
    setCoo(hs, code) {
      this.$set(this.cooTypeByHs, hs, code);
      lsSet(LS_COO_TYPE, this.cooTypeByHs);
    },
    setAllCoo(code) {
      this.cooHsGroups.forEach(g => this.$set(this.cooTypeByHs, g.hs, code));
      lsSet(LS_COO_TYPE, this.cooTypeByHs);
    },
    async downloadCoo() {
      try {
        await this.ensureFixed();
        const info = Object.assign({}, this.info, { importer: this.importer });
        const list = this.cooFiles.map(f => ({ name: cooFileName(f, info, this.model), data: writeCooXlsx(f, this.model, info, this.cooInfo) }));
        this.cooDoneSig = this.cooSig;
        this.saveRecord(true);
        if (list.length === 1) {
          this.saveFile(list[0].data, list[0].name, XLSX_MIME);
          return;
        }
        // 여러 파일은 zip 하나로 — 연속 다운로드는 브라우저가 막는 경우가 있다
        const co = this.model.companyids.join('+');
        const d = String(info.date || '').replace(/-/g, '').slice(4);
        const base = '产地证_' + (info.importer.name || co) + '_(' + co + ')_' + d + '（' + list.length + '个文件）';
        this.saveFile(zipFiles(list), base.replace(/[\\/:*?"<>|\r\n]+/g, ' ').trim() + '.zip', 'application/zip');
      } catch (e) {
        console.error('원산지증명 생성 실패:', e);
        alert('生成失败(생성 실패): ' + e.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inv-gen {
  &__gap { gap: 8px; }
  &__file { width: auto; font-size: 12px; }
  &__set { font-weight: normal; font-size: 12px; text-transform: none; } // 화주 id 대소문자 그대로
  &__fname { font-weight: normal; font-size: 12px; text-transform: none; }

  // ── 단계 구역 ①~⑤(2026-10-06 YZY 「太乱了」) — 제목·간격을 한 모양으로
  &__sec {
    background: #fff;
    border: 1px solid #d5dbe1;
    border-radius: 6px;
    padding: 12px 14px;
    margin-bottom: 12px;
    &--main { border: 2px solid #0b5f86; }
  }
  &__sech {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 15px;
    font-weight: 700;
    color: #1f2933;
    margin: 0 0 10px;
    small { font-weight: normal; font-size: 12px; color: #4b5563; }
  }
  &__step {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #1f2933;
    color: #fff;
    font-size: 12px;
  }
  &__subh { font-weight: 700; color: #1f2933; margin-bottom: 8px; }
  &__ubox {
    height: 100%;
    border: 1px solid #e1e6eb;
    border-radius: 6px;
    background: #f7f9fb;
    padding: 10px;
  }
  &__ulabel { font-weight: 700; color: #1f2933; margin-bottom: 6px; }
  &__batch + &__batch { margin-top: 10px; padding-top: 10px; border-top: 1px dashed #d5dbe1; }
  &__cta { font-weight: 700; }
  &__empty { font-size: 13px; color: #4b5563; }
  &__row-warn td { background: #fff4e5; }

  // 상태 메시지 — 아이콘 + 진한 글자 + 옅은 바탕(테마의 연두·연분홍 글자는 흰 바탕 대비 2:1 대라 안 쓴다)
  &__msg {
    display: inline-block;
    font-size: 13px;
    line-height: 1.4;
    padding: 3px 8px;
    border-radius: 4px;
    border: 1px solid transparent;
    &--ok { color: #14532d; background: #e7f5ec; border-color: #9fd3b1; }
    &--warn { color: #6b3d00; background: #fff4e0; border-color: #f0c27a; }
    &--err { color: #8b1a1a; background: #fdecec; border-color: #f1a7a7; }
    &--info, &--busy { color: #1f3a5f; background: #eef3f8; border-color: #c4d3e3; }
  }
  // 긴 설명 = 접어 둔다
  &__help {
    font-size: 12px;
    color: #374151;
    summary { cursor: pointer; color: #0b5f86; font-weight: 600; width: max-content; }
    &[open] { background: #f7f9fb; border-radius: 4px; padding: 6px 8px; }
  }

  // 테마 글자색(연두 #78C091·연주황·연분홍·하늘)은 흰 바탕 대비가 2:1 대 → 이 화면에서만 AA(4.5:1) 이상으로
  .text-success { color: #1e6b37 !important; }
  .text-warning { color: #8a4b00 !important; }
  .text-danger { color: #b3261e !important; }
  .text-primary { color: #0b5f86 !important; }
  .text-muted { color: #4b5563 !important; }
  a:not(.btn) { color: #0b5f86; }
  a.text-danger { color: #b3261e !important; }
  // 버튼 위계 — 주 동작(④ 일괄 생성)만 꽉 찬 진한 파랑, 나머지는 흰 바탕 보조
  ::v-deep .btn-primary {
    background: #0b5f86; border-color: #0b5f86; color: #fff;
    &:hover:not(:disabled) { background: #084a69; border-color: #084a69; }
  }
  ::v-deep .btn-outline-primary,
  ::v-deep .btn-outline-secondary {
    background: #fff; border-color: #8d99a6; color: #1f2933;
    &:hover:not(:disabled), &:focus { background: #eef2f5; border-color: #5d6b78; color: #111827; }
    &.active, &:not(:disabled):not(.disabled):active { background: #1f2933; border-color: #1f2933; color: #fff; }
  }
  ::v-deep .btn-outline-danger {
    background: #fff; border-color: #b3261e; color: #b3261e;
    &:hover:not(:disabled) { background: #fdecec; color: #8b1a1a; }
  }
  ::v-deep .btn-link { color: #0b5f86; }
  ::v-deep .btn:disabled, ::v-deep .btn.disabled { opacity: 0.45; }
  &__lic { position: relative; }
  &__lic-list { position: absolute; z-index: 20; left: 0; right: 0; top: 100%; max-height: 260px; overflow-y: auto; background: #fff; border: 1px solid #8d99a6; border-radius: 4px; box-shadow: 0 4px 12px rgba(0,0,0,.15); min-width: 260px; }
  &__lic-grp { padding: 3px 8px; font-size: 11px; font-weight: bold; color: #5d6b78; background: #f1f4f7; }
  &__lic-item { padding: 4px 8px; font-size: 12px; cursor: pointer; &:hover { background: #e3eeff; } &.is-on { font-weight: bold; background: #eef6ff; } }
  &__setcoo { width: auto; height: 24px; font-size: 12px; padding-top: 0; padding-bottom: 0; }
  &__vol { width: 84px; height: 24px; font-size: 12px; padding: 0 4px; }
  &__voltab { width: auto; td input { width: 110px; } }
  &__match td { vertical-align: middle; }
  &__coo {
    max-height: 320px;
    overflow-y: auto;
  }
  // 출고리스트 올린 뒤 托盘号 표 — 화면 높이 대부분을 쓴다(2026-10-04 YZY 「表格窗口太小」)
  &__pallets {
    max-height: 65vh;
    min-height: 200px;
    overflow-y: auto;
  }
  &__pfilter ::v-deep .dropdown-menu {
    max-height: 60vh;
    overflow-y: auto;
    min-width: 240px;
  }
  // 표가 길어도 머리행이 보이게(2026-10-04 YZY)
  &__pallets, &__coo {
    // 전역 .table 의 overflow:hidden 이 sticky 를 막는다(표가 스크롤 상자가 됨) → 여기서만 푼다
    table { overflow: visible; }
    thead th {
      position: sticky;
      top: 0;
      z-index: 2;
    }
  }
  &__preview {
    font-size: 13px;
    td { vertical-align: middle; }
    input { min-width: 80px; }
  }
  // 입력칸 — 채운 칸 = 흰 배경, 빈 칸 = 옅은 노랑 + 점선(2026-10-04 YZY 「已经填写的格和空着的格区分开」).
  // placeholder 는 칸 이름일 뿐 값이 아니다 → 흐린 기울임꼴
  input.form-control, textarea.form-control { background-color: #fff; }
  input.form-control:placeholder-shown, textarea.form-control:placeholder-shown {
    background-color: #fff8db;
    border: 1px dashed #d9a92b;
  }
  input.form-control::placeholder, textarea.form-control::placeholder {
    color: #8a7433; // 칸 이름 — 흐리되 읽히게(이전 #b9a46a 는 옅은 노랑 위에서 안 읽혔다)
    font-style: italic;
  }
  // 고정 申报金额 쓴 행(2026-10-11 YZY) — 서류(xlsx)와 같은 노란색
  tr.inv-gen__fixedrow > td { background-color: #ffff00 !important; }
  .inv-gen__fixedmsg { background: #fff9c4; border: 1px solid #e0c200; color: #5b4a00; padding: 4px 8px; border-radius: 3px; }
  // 손으로 고친 부피·중량 칸(2026-10-07 YZY) — 파란 칸 + 굵은 글자. 자동값으로 되돌리면 원래 모양
  input.form-control.inv-gen__edited {
    background-color: #e3eeff;
    border: 2px solid #2f6fd6;
    color: #0b3a8a;
    font-weight: 700;
  }
  // 고르는 칸(货主·发货人·印章·营业执照·港口…) — ▼ 를 보이게(2026-10-04 YZY 「下拉选择的格给弄箭头」)
  select.form-control {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23555'/%3E%3C/svg%3E") no-repeat right 0.5rem center / 10px 6px;
    padding-right: 1.75rem;
    // 테마 line-height(30px)가 칸 높이와 같아 appearance:none 이면 글자가 아래로 잘린다 → 칸 안에 맞춘다
    line-height: 1.4;
    cursor: pointer;
  }
}
</style>
